// @ts-nocheck
import React, { useRef } from "react";
import {
  Box,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  styled,
  TableBody,
  TableSortLabel,
  IconButton,
  Icon,
  Tooltip,
  Button,
  CircularProgress,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import SortArrow from "../../../../assets/images/sort-arrow.svg";
import { LocalizationProvider } from "@mui/x-date-pickers";

// // utils
import { isArray, isUndefined } from "lodash";
import {
  convertFromGivenTimezoneToUTC,
  getTSeparatedDate,
} from "../../../../utils/methods/dateAndTimeMethods";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import { ALERT_DIALOG } from "../../../../store/constants/auth";
import { getCssVariableHandler } from "../../../../utils/styles/getCssVariables";

import { useSelector } from "react-redux";
import {
  addMultiplePositionAction,
  deleteMultiplePositionAction,
  deletePositionAction,
  getSessionssOfSpecificEvent,
} from "../../../../store/actions/createEvent";
import {
  ADD_SESSION_POSITION_REQUEST,
  ADD_SESSION_POSITION_SUCCESS,
  SET_SESSION_STEP_2_DYNAMIC_POSITIONS,
} from "../../../../store/constants/createEvent";
import {
  alertDialogAciton,
  toggleHelper,
} from "../../../../store/actions/auth";
import { ADD_NEW_POSITION_FAILURE } from "../../../../store/constants/eventRequestDetails";
import { getSelectedOption } from "../../../../utils/methods/formatters";
import LineClamp from "../../../positions/components/LineClamp";
import { GmailCheckbox } from "./_components/GmailCheckbox";
import { useState } from "react";
import { useCallback } from "react";
import SheetSearchInput from "./_components/SheetSearch";
import SheetFilterDropdown from "./_components/MultiSelector";
import { SheetDropdown } from "./_components/SheetDropdown";
import { EditableCell } from "./_components/SheetEditableCell";
import { SheetTimeDropdown } from "./_components/SheetTimeDropdown";
import { Close, ContentCopy, DeleteOutline } from "@mui/icons-material";
import RightClick, {
  RightCheckBoxClick,
} from "../../../event-details/components/additionalComponents/RightClick";
import {
  addMultiplePositionsOfMultipleSessionsAction,
  updateMultiplePositionsOfMultipleSessionsAction,
} from "../../../../store/actions/createEventActions2";
import LoadingOverlay from "../../../../components/Custom/LoadingOverlay";
import {
  StyledTableCell,
  TableCellWithError,
} from "./_components/SessionPositionEditableSheetTableCell";
import SessionSelectorForPositionBoard from "../sessions/step2/SessionSelectorForPositionBoard";
import GenericTransparentBtn from "../../../../components/Custom/GenericTransparentBtn";
import { timeInAndTimeOutFromStartDate } from "../sessions/sessionHandlers";
import { SheetCheckBox } from "./_components/SheetCheckBox";
import InfoImage from "../../../../assets/createEvent/small-info.svg";
import { CustomSwitch } from "../../../../components/Custom/Switch";
import CustomHelper from "../../../../components/Helper/CustomHelper";
import { useMemo } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { KeyboardArrowRight } from "@mui/icons-material";
import { CustomIconButtonForSheet } from "../../../../components/Custom/CustomIconButton";
import { refreshPositionAction } from "../../../../store/actions/eventRequestDetails";
import { getUniversalDateTimeFormat } from "../../../../utils/methods/universalDateTimeFormat";
import { addEditLogAction, addLogAction } from "../../../../store/actions/logs";
import { useEffect } from "react";
import _ from "lodash";
import { isTimeTBD } from "../../../../appCalcutions";
import { FRONTEND_CONFIG } from "../../../../utils/constants/configs";
import { SheetPositionDropdown } from "./_components/SheetPositonSelection";
import { apiRequest } from "../../../../services/apiService";

// NOTE: custom components
const StyledTable = styled(Table)(({ theme }) => ({
  border: "2px solid",
  borderRadius: "0.5rem",
  py: "0.25rem",
  borderColor: getCssVariableHandler({ variableName: "--primary-pink-hex" }),
  "& td": {
    borderBottom: "0.5px solid",
    borderColor: "#5e5c5c",
  },
}));

const StyledTableHeadRow = styled(TableRow)(({ theme }) => ({
  "& th": {
    backgroundColor: getCssVariableHandler({
      variableName: "--primary-pink-hex",
    }),
    color: theme.palette.common.white,
    padding: "0.25rem",
    // paddingLeft: "1rem",
    fontSize: "1rem !important",
    fontWeight: 600,
    textAlign: "center",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme, index }) => ({
  backgroundColor: index % 2 === 0 ? "#1A1A1A" : "#2A2A2A",
  transition: "background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
  borderBottom: "1px solid #5e5c5c",

  "&:hover": {
    backgroundColor: "#545454",
    boxShadow: "0px 4px 10px rgba(255, 255, 255, 0.1)",
    transform: "scale(1.0001)",
    zIndex: 10,
  },
}));

// NOTE: style for modal
const style = {
  // position: "absolute",
  // top: "50%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  boxShadow: 24,
  p: 4,
  pb: 0,
  borderRadius: "16px",
  padding: "20px",
  border: "2px solid #D175B6",
  backgroundColor: "#000",
  zIndex: 9,
};

/**
 * function which returns the spreadsheet modal of the all positions in depth
 * @param {Object} param0
 * @param {Function} param0.successCallback - save function
 * @param {Object} param0.data
 * @param {Object} param0.session - current selected session
 * @param {Array} param0.sessions - all sessions
 * @param {Object} param0.eventInfo
 * @param {Boolean} param0.open
 * @param {Function} param0.handleClose
 */
export default function SessionPositionEditableSheet({
  successCallback,
  data,
  session,
  sessions,
  eventInfo,
  open,
  handleClose: handleCloseSheet,
  sessionList,
  selectSession,
  hideSessions,
  isManagePositions,
  hideDelete,
  viewPositionsData,
  setViewPositionsData,
  isEditMultiple,
  isPositionBoard = false,
  allowCopyPositions = false,
}) {
  var previousRowDate = null;
  // Refs start...
  const dontRunOnMount = React.useRef({
    sorting: false,
  });
  // Refs end...

  const sortingInitialValue = React.useMemo(
    () => ({
      positionName: "asc",
      dateStart: "asc",
      fieldChange: null,
    }),
    [],
  );

  const filtersInitialValue = React.useMemo(
    () => ({
      sessionId: {
        searchStr: "",
        searchStrPrev: "",
        startDate: [],
        startDatePrev: [],
        positionName: [],
        positionNamePrev: [],
      },
    }),
    [],
  );

  const checkBoxContextInitialValues = React.useMemo(
    () => ({
      status: false,
      mouseY: null,
      mouseX: null,
      collapsed: null,
      id: null,
      sessionId: null,
      type: "COPY",
    }),
    [],
  );

  // media query hooks...
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks...

  const [dateChangedIdx, setDateChangedIdx] = React.useState(null);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [isDelBtnLoading, setIsDelBtnLoading] = useState(false);
  const [contextMenu, setContextMenu] = React.useState({
    status: false,
    mouseY: null,
    mouseX: null,
    value: null,
    field: null,
    id: null,
    sessionId: null,
  });
  const [checkBoxContextMenu, setCheckBoxContextMenu] = React.useState(
    checkBoxContextInitialValues,
  );
  const [copiedRows, setCopiedRows] = React.useState([]);
  const [sorting, setSorting] = React.useState(sortingInitialValue);
  const [filters, setFilters] = useState(filtersInitialValue);
  const [selectedPositions, setSelectedPositions] = useState([]);
  const [updatedPositionsIds, setUpdatedPositionsIds] = useState([]);
  const [sessionSelection, setSessionSelection] = useState({
    status: false,
  });
  const [applyAllFilters, setApplyAllFilters] = React.useState(false);
  // const [formState, setFormState] = React.useState({
  //   values: {},
  // });
  // NOTE: collapse and expand data
  const [collapseDate, setCollapseDate] = useState({});
  const [suffixData, setSuffixData] = useState({});
  const [deletedPositionIds, setDeletedPositionsIds] = useState(null);
  const [deletePositionsDetails, setDeletedPositionsDetails] = useState([]);
  const [showSave, setShowSave] = useState(isManagePositions ? true : false);
  const [pause, setPause] = useState(false);

  const createContactInfo = useSelector((state) => state.createContactInfo);
  const pastePositionIds = useRef(10000);
  const auth = useSelector((state) => state.auth);
  const { helpStatus } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // ── Who to notify ──
  // Autosave is silent: the backend never emails on it (2026-09-30: every autosave
  // used to email the technicians, half-typed times included). Shifts saved while the
  // sheet is open are remembered here. Closing emails nobody unless the checkbox
  // "Notify assigned technicians" is ticked; then the technicians on those shifts get
  // one email with the final saved times. The close prompt that also offered the
  // client was removed on 2026-10-19 (Casper): the client is only emailed through
  // "Share Revised Estimate".
  const positionsToNotifyRef = useRef(new Map());
  const inFlightSavesRef = useRef(new Set());
  const [notifyTechnicians, setNotifyTechnicians] = useState(false);

  const rememberPositionsToNotify = useCallback((list) => {
    (list || []).forEach((item) => {
      const sessionId = item?.sessionId;
      const id = item?.id ?? item?._id;
      if (!sessionId || !id) return;
      positionsToNotifyRef.current.set(`${sessionId}:${id}`, {
        sessionId: String(sessionId),
        id: String(id),
      });
    });
  }, []);

  const trackSave = useCallback((promise) => {
    inFlightSavesRef.current.add(promise);
    promise
      .finally(() => inFlightSavesRef.current.delete(promise))
      .catch(() => {});
    return promise;
  }, []);

  const finishClose = useCallback(() => {
    positionsToNotifyRef.current = new Map();
    setNotifyTechnicians(false);
    handleCloseSheet?.();
  }, [handleCloseSheet]);

  // `positions` is captured by the caller: closing resets the list right away.
  const notifyTechniciansOfChanges = useCallback(async (positions) => {
    // The email reads what is saved: wait for any autosave still in flight.
    await Promise.allSettled(Array.from(inFlightSavesRef.current));
    const { response, error } = await apiRequest({
      method: "POST",
      url: "notifyPositionChanges",
      data: {
        eventId: eventInfo?._id,
        positions,
        notifyAssignedContractors: true,
        clientUpdateEmailRecipients: [],
      },
      isToken: true,
    });
    const ok = response?.status === 200 || response?.status === 201;
    if (!ok) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message:
            error?.response?.data?.message ||
            "The changes were saved, but the technicians could not be notified.",
        }),
      );
    }
  }, [dispatch, eventInfo?._id]);

  // Every close path of the sheet goes through here.
  const handleClose = useCallback(() => {
    if (
      notifyTechnicians &&
      !isManagePositions &&
      eventInfo?.submitted &&
      positionsToNotifyRef.current.size > 0
    ) {
      notifyTechniciansOfChanges(Array.from(positionsToNotifyRef.current.values()));
    }
    finishClose();
  }, [
    notifyTechnicians,
    isManagePositions,
    eventInfo?.submitted,
    notifyTechniciansOfChanges,
    finishClose,
  ]);

  // Static data start...
  const initialValues = React.useMemo(() => {
    return {
      positions: [],
    };
  }, []);

  const lunchOptions = React.useMemo(
    () => [
      {
        label: "MP",
        value: "meal provided",
      },
      {
        label: "WA",
        value: "1 hour walk away",
      },
      {
        label: "N/A",
        value: "NA",
      },
    ],
    [],
  );
  const complexityOptions = React.useMemo(
    () => [
      {
        label: "none",
        value: "none",
      },
      {
        label: "low",
        value: "low",
      },
      {
        label: "medium",
        value: "medium",
      },
      {
        label: "high",
        value: "high",
      },
    ],
    [],
  );

  const attireOptions = React.useMemo(
    () => [
      {
        label: "Blacks (Shorts OK)",
        value: "Blacks (Shorts OK)",
      },
      {
        label: "Tech Blacks",
        value: "Tech Blacks",
      },
      {
        label: "Show Blacks",
        value: "Show Blacks",
      },
      {
        label: "Dress Blacks",
        value: "Dress Blacks",
      },
    ],
    [],
  );
  // Static data end...

  // Handlers start...
  const getOptionsHandler = (sessionId, all = false) => {
    const positionOptions = Array.from(
      new Map(
        data
          ?.filter?.((item) => {
            return all ? true : item?.session?._id === sessionId;
          })
          ?.map((item) => [
            item?.positionId,
            {
              value: item?.positionId,
              name: item?.positionName,
              sessionId: item?.session?._id,
            },
          ]),
      ).values(),
    );

    const startDateOptions = Array.from(
      new Map(
        data
          ?.filter?.((item) => {
            return all ? true : item?.session?._id === sessionId;
          })
          ?.map((item) => [
            item?.startDate,
            {
              value: item?.startDate,
              name: dayjs(item?.startDate).format("ddd MM/DD/YYYY"),
              sessionId: item?.session?._id,
            },
          ]),
      ).values(),
    );

    return { positionOptions, startDateOptions };
  };

  const getTimeInAndTimeOutDates = (startDate, time) => {
    const dt = dayjs(startDate).toDate();
    let hour;
    let min;

    const splittedTime = time?.split?.("T")?.[1];
    hour = splittedTime?.split?.(":")?.[0];
    min = splittedTime?.split?.(":")?.[1];

    dt.setHours(hour);
    dt.setMinutes(min);

    return dt;
  };

  const datesForDropDown = (start, end) => {
    const sessionEnd = dayjs(end);
    const datesBetween = [];
    let currentDate = dayjs(start);

    while (currentDate <= sessionEnd) {
      datesBetween.push(currentDate);
      currentDate = currentDate.add(1, "day");
    }

    return datesBetween;
  };

  const sessionDatesForDropdown = React.useMemo(() => {
    return datesForDropDown(session?.sessionStart, session?.sessionEnd)?.map(
      (item) => {
        return {
          label: dayjs(item).format("ddd MM/DD/YYYY"),
          value: dayjs(item).format("YYYY-MM-DD"),
        };
      },
    );
  }, [session]);

  const sessionDatesForDropdownV2 = React.useMemo(() => {
    let result = {};
    sessions?.forEach((item) => {
      result[item?._id] = datesForDropDown(
        item?.sessionStart,
        item?.sessionEnd,
      )?.map((item) => {
        return {
          label: dayjs(item).format("ddd MM/DD/YYYY"),
          value: dayjs(item).format("YYYY-MM-DD"),
        };
      });
    });
    return result;
  }, [sessions]);

  const isValidDateTime = (value) => {
    const dateTime = value?.split?.(".")?.[0];
    return (
      dayjs(dateTime, "YYYY-MM-DDTHH:mm:ss", true).isValid() || isTimeTBD(value)
    );
  };

  const formSchema = Yup.object().shape({
    positions: Yup.array().of(
      Yup.object().shape({
        positionId: Yup.string().trim().required(),
        positionName: Yup.string()
          .trim()
          .max(100, "Position Name should at most 100 characters!")
          .required(),
        startDate: Yup.string().trim().required("Start date required"),
        timeIn: Yup.string()
          .trim()
          .when(["tbd", "overNightShift"], {
            is: (tbd, overNightShift) => tbd === false && !overNightShift,
            then: () =>
              Yup.string()
                .trim()
                .required("Time in is required")
                .test("is-valid-datetime", "Invalid time", (value) =>
                  isValidDateTime(value),
                ),
            otherwise: () =>
              Yup.string().trim().required("Time in is required"),
          }),
        timeOut: Yup.string()
          .trim()
          .when("overNightShift", {
            is: false,
            then: () =>
              Yup.string()
                .trim()
                .required("Time out is required")
                .test("is-valid-datetime", "Invalid time", (value) =>
                  isValidDateTime(value),
                )
                .test(
                  "is-greater-than-or-equal-to-time-in",
                  "Time out can not be earlier than time in, it must be an overnight shift",
                  function () {
                    if (this.parent.overNightShift) return true;
                    if (
                      isTimeTBD(this.parent.timeIn) &&
                      isTimeTBD(this.parent.timeOut)
                    )
                      return true;

                    if (this.parent.timeIn && this.parent.timeOut) {
                      const timeInDate = dayjs(this.parent.timeIn).format(
                        "HH:mm:ss",
                      );
                      const timeOutDate = dayjs(this.parent.timeOut).format(
                        "HH:mm:ss",
                      );

                      const t1 = dayjs(`2000-01-01T${timeInDate}`);
                      const t2 = dayjs(`2000-01-01T${timeOutDate}`);
                      return t2.isAfter(t1, "minute");
                    }
                    return true;
                  },
                ),
          }),
        tbd: Yup.boolean(),
        numberOfHours: Yup.number()
          .typeError("No. of hours must be a number")
          .when(["timeIn", "timeOut"], {
            is: (timeIn, timeOut) => timeIn === "TBD" || timeOut === "TBD",
            then: () => Yup.number().required("No. of hours required"),
            otherwise: (schema) => schema.notRequired(),
          }),
        overNightShift: Yup.boolean().required("Overnight shift required!"),
        selectOption: Yup.string().trim(),
        quantity: Yup.string().trim().notOneOf(["0"], "Quantity can't be zero"),
        additionalComments: Yup.string()
          .nullable()
          .trim()
          .max(2000, "Maximum limit reached"),
        attire: Yup.string().trim(),
      }),
    ),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: formSchema,
    onSubmit: (values) => {
      const payload = {
        positions: [],
      };

      payload.positions = values?.positions?.map((pos) => {
        const timeInAndOut = timeInAndTimeOutFromStartDate(pos, pos?.startDate);
        return {
          ...pos,
          timeIn: !isTimeTBD(pos?.timeIn)
            ? convertFromGivenTimezoneToUTC({
                date: timeInAndOut?.timeIn,
                timezone: eventInfo?.eventTimezone,
              })
            : "TBD",
          timeOut: !isTimeTBD(pos?.timeOut)
            ? convertFromGivenTimezoneToUTC({
                date: timeInAndOut?.timeOut,
                timezone: eventInfo?.eventTimezone,
              })
            : "TBD",
        };
      });

      // NOTE: api call handling here
      dispatch(
        addMultiplePositionAction({
          sessionId: session?._id,
          eventInfo,
          payload,
          positions: values?.positions,
          beforeCallback: () => {
            dispatch({ type: ADD_SESSION_POSITION_REQUEST });
            setIsBtnLoading(true);
          },
          afterCallback: () => {
            setIsBtnLoading(false);
          },
          successCallback: ({ response }) => {
            dispatch({
              type: ADD_SESSION_POSITION_SUCCESS,
              payload: {
                res: response?.data,
                formData: null,
              },
            });
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message: "Position added successfully",
              }),
            );
            setValues(initialValues);
            successCallback();
            dispatch({
              type: SET_SESSION_STEP_2_DYNAMIC_POSITIONS,
              payload: {
                dynamicPositionsForm: null,
              },
            });
            handleClose();
          },
          failureCallback: ({ error }) => {
            dispatch({ type: ADD_NEW_POSITION_FAILURE });

            dispatch({
              type: ALERT_DIALOG,
              payload: {
                open: true,
                title: "Error!",
                message:
                  error?.response?.data?.message ||
                  error?.response?.data?.error ||
                  "Some error occured!",
              },
            });
            setValues(initialValues);
          },
        }),
      );
    },
  });

  const { values, setValues, errors, submitForm, setFieldValue, resetForm } =
    formik;

  const options = React.useMemo(() => {
    const positionOptions = Array.from(
      new Map(
        data?.map((item) => [
          item?.positionId,
          {
            value: item?.positionId,
            name: item?.positionName,
            sessionId: item?.session?._id,
          },
        ]),
      ).values(),
    );

    const startDateOptions = Array.from(
      new Map(
        data?.map((item) => [
          item?.startDate,
          {
            value: item?.startDate,
            name: dayjs(item?.startDate).format("ddd MM/DD/YYYY"),
            sessionId: item?.session?._id,
          },
        ]),
      ).values(),
    );

    return { positionOptions, startDateOptions };
  }, [data]);

  const getSessionPositions = React.useMemo(() => {
    let sPositions = {};
    data?.forEach((item) => {
      const sessionId = item?.session?._id;

      if (!sPositions[sessionId]) {
        sPositions[sessionId] = []; // Initialize as an empty array
      }

      sPositions[sessionId].push(item?._id);
    });

    return sPositions;
  }, [data]);

  const doesSelectedPositionIncludes = React.useCallback(
    (sessionId) => {
      let result = false;
      selectedPositions?.forEach((item) => {
        if (getSessionPositions?.[sessionId]?.includes(item)) {
          result = true;
        }
      });
      return result;
    },

    [getSessionPositions, selectedPositions],
  );

  const sortedPositions = React.useMemo(() => {
    let sortedPositions = [...data]
      ?.sort((a, b) => {
        const fieldA = a?.positionName?.toLowerCase?.() || "";
        const fieldB = b?.positionName?.toLowerCase?.() || "";

        return sorting?.positionName === "asc"
          ? fieldA.localeCompare(fieldB)
          : fieldB.localeCompare(fieldA);
      })
      ?.sort((a, b) => {
        return sorting.dateStart === "asc"
          ? Date.parse(a.startDate) - Date.parse(b.startDate)
          : Date.parse(b.startDate) - Date.parse(a.startDate);
      });
    return sortedPositions;
    // eslint-disable-next-line
  }, [data]);

  const renderPositions = React.useMemo(() => {
    if (!values?.positions || values?.positions?.length == 0) return [];

    // Sort positions
    let sortedPositions;
    if (sorting?.fieldChange) {
      sortedPositions = [
        ...(values?.positions?.sort((a, b) => {
          if (sorting?.fieldChange === "dateStart") {
            return sorting.dateStart === "asc"
              ? Date.parse(a.startDate) - Date.parse(b.startDate)
              : Date.parse(b.startDate) - Date.parse(a.startDate);
          }

          const fieldA = a?.[sorting?.fieldChange]?.toLowerCase?.() || "";
          const fieldB = b?.[sorting?.fieldChange]?.toLowerCase?.() || "";

          return sorting?.[sorting?.fieldChange] === "asc"
            ? fieldA.localeCompare(fieldB)
            : fieldB.localeCompare(fieldA);
        }) || []),
      ];
    } else {
      sortedPositions = [...(values?.positions || [])];
    }

    // Filter positions
    sortedPositions = sortedPositions?.filter((item) => {
      if (!filters?.[applyAllFilters ? "all" : item?.session?._id]) {
        return true;
      } else {
        return item?.positionName
          ?.toLowerCase()
          ?.includes(
            filters?.[applyAllFilters ? "all" : item?.session?._id]?.searchStr
              ?.toLowerCase?.()
              ?.trim?.() || "",
          );
      }
    });

    sortedPositions = sortedPositions?.filter((item) => {
      if (!filters?.[applyAllFilters ? "all" : item?.session?._id]) {
        return true;
      } else {
        const positionList =
          filters?.[
            applyAllFilters ? "all" : item?.session?._id
          ]?.positionName?.map((item) => item?.value) || [];
        if (positionList?.length === 0) {
          return true;
        } else {
          return positionList?.includes(item?.positionId);
        }
      }
    });

    sortedPositions = sortedPositions?.filter((item) => {
      if (!filters?.[applyAllFilters ? "all" : item?.session?._id]) {
        return true;
      } else {
        const dateList =
          filters?.[
            applyAllFilters ? "all" : item?.session?._id
          ]?.startDate?.map?.((item) => item?.value) || [];
        if (dateList?.length === 0) {
          return true;
        } else {
          return dateList?.includes(item?.startDate);
        }
      }
    });

    return sortedPositions;
  }, [values, sorting, filters, applyAllFilters]);

  const positionErrorMap = React.useMemo(() => {
    if (!errors.positions || !values.positions) return {};

    return values.positions.reduce((acc, pos, idx) => {
      const error = errors.positions?.[idx];
      if (error) acc[pos?._id] = error;
      return acc;
    }, {});
  }, [values.positions, errors.positions]);

  // callbacks
  const positionCheckBoxClickAction = useCallback((positionId) => {
    setSelectedPositions((prev) => {
      const index = prev.indexOf(positionId);
      if (index > -1) {
        // If already selected, remove it (avoid array recreation)
        const newPositions = [...prev];
        newPositions.splice(index, 1);
        return newPositions;
      } else {
        // If not selected, add it
        return [...prev, positionId];
      }
    });
  }, []);

  const positionCheckBoxCollapsedClickAction = useCallback(
    (posIds, isAllSelected, indeterminated) => {
      if (isAllSelected || indeterminated) {
        setSelectedPositions((prev) =>
          prev?.filter((pos) => !posIds?.includes(pos)),
        );
      } else {
        setSelectedPositions((prev) => {
          return Array.from(new Set([...prev, ...posIds]));
        });
      }
    },
    [setSelectedPositions],
  );

  const isIndeterminateOnCollapse = useCallback(
    (posIds) => {
      const selectedCount = posIds?.filter((pos) =>
        selectedPositions?.includes(pos),
      ).length;
      return selectedCount > 0 && selectedCount < posIds.length;
    },
    [selectedPositions],
  );

  const isAllSelected = useCallback(
    (posIds) => {
      return posIds?.every((pos) => selectedPositions?.includes(pos));
    },
    [selectedPositions],
  );

  const headerCheckBoxClickAction = useCallback(
    (sessionId) => {
      setSelectedPositions((prev) => {
        return prev.length ===
          values?.positions?.filter?.(
            (item) => item?.session?._id === sessionId,
          )?.length
          ? []
          : [
              ...(values?.positions
                ?.filter?.((item) => item?.session?._id === sessionId)
                ?.map((item) => item?._id) || []),
            ];
      });
    },
    [values],
  );

  const handleApplyTo = useCallback(
    (type) => {
      const visiblePositionsIds = renderPositions
        ?.filter?.((item) => {
          return item?.session?._id === contextMenu?.sessionId;
        })
        ?.map((item) => item?._id);
      let uIds = new Set();

      setValues((prev) => {
        const updatedPositions = prev.positions.map((row) => {
          if (!visiblePositionsIds?.includes(row?._id)) return row;

          if (type === "SELECTED" && !selectedPositions?.includes(row?._id)) {
            return row;
          }

          // if (contextMenu?.field == "timeIn") {
          //   uIds.add(row?._id);
          //   let newTime = "TBD";
          //   if (!isTimeTBD(contextMenu?.value)) {
          //     const result = contextMenu?.value?.split("T");
          //     newTime = `${row?.startDate}T${result?.[1]}`;
          //   }
          //   return {
          //     ...row,
          //     [contextMenu?.field]: newTime,
          //     tbd: newTime === "TBD",
          //   };
          // }
          //
          // if (contextMenu?.field == "timeOut") {
          //   uIds.add(row?._id);
          //   let newTimeOut = "TBD";
          //   if (!isTimeTBD(contextMenu?.value)) {
          //     const newTime = dayjs(contextMenu?.value);
          //     const hour = newTime?.$H;
          //     const min = newTime?.$m;
          //
          //     const dt = row?.startDate
          //       ? dayjs(row?.startDate).toDate()
          //       : dayjs(session?.sessionStart).toDate();
          //     dt?.setHours(hour);
          //     dt?.setMinutes(min);
          //     newTimeOut = getTSeparatedDate(dt);
          //   }
          //   return {
          //     ...row,
          //     [contextMenu?.field]: newTimeOut,
          //     tbd: newTimeOut === "TBD",
          //   };
          // }
          //
          // if (contextMenu?.field == "overnight") {
          //   uIds.add(row?._id);
          //   let newTime = "TBD";
          //   if (!isTimeTBD(row?.timeOut)) {
          //     newTime = overnightTimeOut(row, contextMenu?.value);
          //   }
          //   return {
          //     ...row,
          //     [contextMenu?.field]: newTime,
          //     timeOut: newTime,
          //   };
          // }

          if (contextMenu.field) {
            uIds.add(row?._id);
            return { ...row, [contextMenu.field]: contextMenu.value };
          }
          return row;
        });

        formik.validateForm();
        return { positions: updatedPositions };
      });
      setUpdatedPositionsIds((prev) => Array.from(new Set([...prev, ...uIds])));

      setContextMenu({
        status: false,
        mouseY: null,
        mouseX: null,
        value: null,
        field: null,
        id: null,
        sessionId: null,
      });
    },
    [
      session?.sessionStart,
      setValues,
      setContextMenu,
      contextMenu,
      selectedPositions,
      renderPositions,
    ],
  );

  // const handleInsertDirect = useCallback(
  //   (list = null) => {
  //     const customList = list;
  //     const listIds = list?.map((i) => i?._id);
  //
  //     let iterationIdx = 0;
  //
  //     setValues((prev) => {
  //       const updatedPositions = [];
  //
  //       prev.positions.forEach((row, i) => {
  //         data?.forEach((drow, idx) => {
  //           if (idx < iterationIdx) {
  //             continue;
  //           }
  //           if (listIds?.includes(drow?._id)) {
  //             updatedPositions?.push(
  //               customList?.find((i) => i?._id == drow?._id),
  //             );
  //             iterationIdx = idx;
  //           }
  //         });
  //         updatedPositions.push(row);
  //       });
  //
  //       return { positions: updatedPositions };
  //     });
  //     setDeletedPositionsDetails((prev) =>
  //       prev?.filter((i) => listIds?.includes(i?._id)),
  //     );
  //   },
  //   [setValues, data],
  // );

  const handleInsertDirect = useCallback(
    (list = []) => {
      if (!Array.isArray(list) || list.length === 0) return;

      const listMap = new Map(list.map((i) => [i._id, i]));
      const listIds = new Set(list.map((i) => i._id));

      let iterationIdx = 0;

      setValues((prev) => {
        const updatedPositions = [];
        const addedIds = new Set();

        for (let i = 0; i < prev.positions.length; i++) {
          const row = prev.positions[i];

          for (let idx = iterationIdx; idx < (data?.length || 0); idx++) {
            const drow = data[idx];

            if (listIds.has(drow?._id) && !addedIds.has(drow._id)) {
              updatedPositions.push(listMap.get(drow._id));
              addedIds.add(drow._id);
              iterationIdx = idx + 1;
            }
          }

          if (!addedIds.has(row._id)) {
            updatedPositions.push(row);
            addedIds.add(row._id);
          }
        }

        if (data) {
          for (let idx = iterationIdx; idx < data.length; idx++) {
            const drow = data[idx];
            if (listIds.has(drow?._id) && !addedIds.has(drow._id)) {
              updatedPositions.push(listMap.get(drow._id));
              addedIds.add(drow._id);
            }
          }
        }

        return { positions: updatedPositions };
      });

      setDeletedPositionsDetails((prev) =>
        prev?.filter((i) => !listIds.has(i?._id)),
      );
    },
    [setValues, setDeletedPositionsDetails, data],
  );

  const handleInsert = useCallback(
    (type) => {
      const visiblePositionsIds = renderPositions?.map((item) => item?._id);
      let uIds = new Set();

      function getKeyName(pos) {
        return `${pos?.startDate}-${pos?.positionId}`;
      }

      setValues((prev) => {
        const updatedPositions = [];
        let dateMap = {};
        if (type === "PASTE_DATE") {
          copiedRows?.forEach((item) => {
            const keyName = getKeyName(item);
            if (!dateMap[keyName]) {
              dateMap[keyName] = [item];
            } else {
              dateMap[keyName]?.push(item);
            }
          });
        }

        prev.positions.forEach((row, i) => {
          if (type === "PASTE_DATE") {
            updatedPositions.push(row);
            const keyName = getKeyName(row);

            if (dateMap[keyName]) {
              if (Object.keys(dateMap)?.includes(keyName)) {
                dateMap[keyName].forEach((item) => {
                  pastePositionIds.current += 1;
                  uIds.add(pastePositionIds.current);
                  updatedPositions.push({
                    ...item,
                    positionOrder: " New",
                    session: { _id: checkBoxContextMenu?.sessionId },
                    _id: pastePositionIds.current,
                  });
                });
                delete dateMap[keyName];
              }
            }
          } else {
            if (!visiblePositionsIds?.includes(row?._id)) {
              updatedPositions.push(row);
            }

            if (type === "ABOVE" && row?._id === checkBoxContextMenu?.id) {
              copiedRows?.forEach((item) => {
                pastePositionIds.current += 1;
                uIds.add(pastePositionIds.current);
                updatedPositions.push({
                  ...item,
                  positionOrder: " New",
                  session: { _id: checkBoxContextMenu?.sessionId },
                  _id: pastePositionIds.current,
                });
              });
            }
            updatedPositions.push(row);
            if (type === "BELOW" && row?._id === checkBoxContextMenu?.id) {
              copiedRows?.forEach((item) => {
                pastePositionIds.current += 1;
                uIds.add(pastePositionIds.current);
                updatedPositions.push({
                  ...item,
                  positionOrder: " New",
                  session: { _id: checkBoxContextMenu?.sessionId },
                  _id: pastePositionIds.current,
                });
              });
            }
          }
        });

        return { positions: updatedPositions };
      });
      setUpdatedPositionsIds((prev) => Array.from(new Set([...prev, ...uIds])));

      setCheckBoxContextMenu(checkBoxContextInitialValues);
      setCopiedRows([]);
    },
    [
      setValues,
      setCheckBoxContextMenu,
      checkBoxContextInitialValues,
      checkBoxContextMenu,
      renderPositions,
      copiedRows,
    ],
  );

  // NOTE: set collapse and explandable data
  // basic structure
  // {
  // [sessionId]: {
  //  [date-positionName]: {
  //  startIdx: number,
  //  endIdx: number,
  //  count: number,
  //  status: boolean, // true means collapsed
  //  }
  // }
  // }
  const setCollapseAndExpandableData = useCallback(() => {
    let result = {};
    let suffix = {};
    let suffixMap = {};
    sessions?.forEach((ses) => {
      renderPositions
        ?.filter((item) => item?.session?._id === ses?._id)
        ?.forEach((pos, idx) => {
          const datePosId = getDatePosName(pos);
          const suffixId = generateSuffixFor(pos);
          if (!suffixMap?.[suffixId]) {
            suffixMap[suffixId] = {};
          }
          suffixMap[suffixId].count = (suffixMap?.[suffixId]?.count || 0) + 1;
          if (!suffixMap[suffixId]?._id) {
            suffixMap[suffixId]._id = [];
          }
          suffixMap[suffixId]?._id?.push(pos?._id);
          result[ses?._id] = {
            ...result?.[ses?._id],
            [datePosId]: {
              startIdx: result?.[ses?._id]?.[datePosId]
                ? result?.[ses?._id]?.[datePosId]?.startIdx
                : idx,
              endIdx: idx,
              count: (result?.[ses?._id]?.[datePosId]?.count || 0) + 1,
              status: FRONTEND_CONFIG?.groupedStatus,
              ids: result?.[ses?._id]?.[datePosId]?.ids
                ? [...(result?.[ses?._id]?.[datePosId]?.ids || []), pos?._id]
                : [pos?._id],
            },
          };
          if (isArray(result?.[ses?._id]?.[datePosId]?.Ids)) {
            result?.[ses?._id]?.[datePosId]?.Ids.push(pos?._id);
          } else {
            result[ses?._id][datePosId].Ids = [pos?._id];
          }
        });
    });
    Object.keys(result).forEach((sessionId) => {
      result[sessionId] = Object.fromEntries(
        Object.entries(result[sessionId]).filter(
          ([_, value]) => value.count > 1,
        ),
      );
    });
    Object.keys(suffixMap).forEach((key) => {
      if (suffixMap[key].count === 1) {
        delete suffixMap[key];
      }
    });

    suffix = {};
    Object.entries(suffixMap).forEach(([_, value]) => {
      value._id?.forEach((id, idx) => {
        suffix[id] = idx + 1;
      });
    });

    setSuffixData(suffix);
    setDateChangedIdx((prev) => {
      const mergedResult = { ...prev };

      Object.keys(result).forEach((sessionId) => {
        if (!mergedResult[sessionId]) {
          mergedResult[sessionId] = {};
        }

        Object.entries(result[sessionId]).forEach(([datePosId, value]) => {
          if (mergedResult[sessionId][datePosId]) {
            mergedResult[sessionId][datePosId] = {
              ...mergedResult[sessionId][datePosId],
              ...value,
              status: isUndefined(prev[sessionId][datePosId].status)
                ? value.status
                : prev[sessionId][datePosId].status,
            };
          } else {
            mergedResult[sessionId][datePosId] = value;
          }
        });
        Object.entries(mergedResult[sessionId]).forEach(([datePosId, _]) => {
          if (
            mergedResult[sessionId][datePosId] &&
            !result?.[sessionId]?.[datePosId]
          ) {
            delete mergedResult[sessionId][datePosId];
          }
        });
      });

      return mergedResult;
    });
  }, [renderPositions, sessions]);

  const updateDateChangedIdx = useCallback(
    (newPos, sessionId, prevKey) => {
      const newKey = getDatePosName(newPos);
      setDateChangedIdx((prev) => ({
        ...prev,
        [sessionId]: {
          ...(prev?.[sessionId] || {}),
          [newKey]: { ...prev?.[sessionId]?.[prevKey] },
        },
      }));
    },
    [setDateChangedIdx],
  );

  const isUnfoldAll = useMemo(() => {
    if (!dateChangedIdx) return false;

    let allUnfold = true;
    Object.values(dateChangedIdx || {})?.forEach((sessionData) => {
      if (!sessionData) return;
      Object.values(sessionData || {})?.forEach((item) => {
        if (!item?.status) {
          allUnfold = false;
        }
      });
    });
    return allUnfold;
  }, [dateChangedIdx]);

  const unfoldLessHandler = useCallback(() => {
    setDateChangedIdx((prev) => {
      const updatedState = { ...prev };
      sessions?.forEach((ses) => {
        const updatedSession = { ...updatedState?.[ses?._id] };
        Object.keys(updatedSession)?.forEach((key) => {
          updatedSession[key] = {
            ...updatedSession[key],
            status: true,
          };
        });
        updatedState[ses._id] = updatedSession;
      });
      return updatedState;
    });
  }, [sessions]);

  const unfoldMoreHandler = useCallback(() => {
    setDateChangedIdx((prev) => {
      const updatedState = { ...prev };
      sessions?.forEach((ses) => {
        const updatedSession = { ...updatedState?.[ses?._id] };
        Object.keys(updatedSession)?.forEach((key) => {
          updatedSession[key] = {
            ...updatedSession[key],
            status: false,
          };
        });
        updatedState[ses._id] = updatedSession;
      });
      return updatedState;
    });
  }, [sessions]);

  // NOTE: handle case when new quantity is greater than pervious data by new quantity
  const increaseQuantityOfPositions = useCallback(
    (newVal, posData, reConfirm = true) => {
      function updatedValues(newPoss, pIds) {
        setValues({ positions: newPoss });
        setUpdatedPositionsIds((prev) =>
          Array.from(new Set([...(prev || []), ...(pIds || [])])),
        );
      }

      let updatedPositions = [];
      let uIds = new Set();
      if (reConfirm) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "Warning",
            message: `Are you sure, you want to add ${newVal} more ${posData?.positionName}?`,
            okLabel: "Add",
            onOk: () => {
              // NOTE: add new positions logic here
              values?.positions?.forEach((pos) => {
                if (pos?._id == posData?._id) {
                  Array.from({ length: newVal }, () => {
                    updatedPositions?.push({
                      ...posData,
                      _id: pastePositionIds?.current,
                    });
                    uIds.add(pastePositionIds?.current);
                    pastePositionIds.current += 1;
                  });
                  updatedPositions?.push(pos);
                } else {
                  updatedPositions?.push(pos);
                }
              });
              updatedValues(updatedPositions, uIds);
            },
          }),
        );
      } else {
        // NOTE: add new positions logic here
        values?.positions?.forEach((pos) => {
          if (pos?._id == posData?._id) {
            Array.from({ length: newVal }, () => {
              updatedPositions?.push({
                ...posData,
                _id: pastePositionIds?.current,
              });
              uIds.add(pastePositionIds?.current);
              pastePositionIds.current += 1;
            });
            updatedPositions?.push(pos);
          } else {
            updatedPositions?.push(pos);
          }
        });
        updatedValues(updatedPositions, uIds);
      }
    },
    [setValues, dispatch, values?.positions],
  );

  // NOTE: handle case when new quantity is smaller than previous data by new quantity
  const decreaseQuantityOfPositions = useCallback(
    (newVal, posData, Ids) => {
      function updatedValues(newPoss, pIds) {
        setValues({ positions: newPoss });
      }

      let updatedPositions = [];
      let uIds = new Set();
      let removeIds = Ids?.slice(0, newVal);
      dispatch(
        alertDialogAciton({
          open: true,
          title: isManagePositions
            ? "Warning"
            : "Are you sure you want to proceed?",
          message: isManagePositions
            ? `Are you sure, you want to remove ${newVal} ${posData?.positionName}?`
            : "You can reduce quantity directly from here. However, this may remove positions that are already assigned. To avoid this, we recommend ungrouping the position, selecting the specific rows you want to remove, and using the Delete option.",
          okLabel: "Remove",
          onOk: () => {
            if (isEditMultiple) {
              deleteMultiplePositionsForEdit(
                { [session?._id]: removeIds },
                removeIds,
              );
              return;
            }

            // NOTE: it'll be different for manage positions and preview/edit
            if (isManagePositions) {
              // NOTE: manage position logic here
              updatedPositions = values?.positions?.filter((pos) => {
                return !removeIds?.includes(pos?._id);
              });
              updatedValues(updatedPositions, uIds);
            } else {
              // NOTE: preview/edit logic here
              updatedPositions = values?.positions?.filter((pos) => {
                return removeIds?.includes(pos?._id);
              });

              const updatedData = values?.positions?.filter((pos) => {
                return !removeIds?.includes(pos?._id);
              });

              setIsDelBtnLoading(true);
              const params = {
                eventId: eventInfo?._id,
              };
              const payload = updatedPositions?.map((item) => ({
                id: item,
                sessionId: posData?.session?._id,
              }));
              dispatch(
                deleteMultiplePositionAction({
                  payload: {
                    positions: payload,
                  },
                  params,
                  afterCallback: () => {
                    setIsDelBtnLoading(false);
                  },
                  failureCallback: () => {
                    dispatch(
                      alertDialogAciton({
                        open: true,
                        title: "Error",
                        message: "Failed to delete positions.",
                      }),
                    );
                  },
                  successCallback: () => {
                    if (eventInfo?.submitted) {
                      dispatch(
                        refreshPositionAction({ eventId: eventInfo?._id }),
                      );
                    } else {
                      dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
                    }
                    if (isEditMultiple) {
                      handleClose();
                    }
                    updatedValues(updatedData);
                    setSelectedPositions([]);
                    setIsDelBtnLoading(false);
                    dispatch(
                      alertDialogAciton({
                        open: true,
                        title: "Success",
                        message: "Positions deleted successfully.",
                      }),
                    );
                  },
                }),
              );
            }
          },
        }),
      );
    },
    [
      eventInfo?.submitted,
      setValues,
      dispatch,
      isManagePositions,
      eventInfo?._id,
      values?.positions,
      handleClose,
      isEditMultiple,
    ],
  );

  function isValidMongoObjectId(id) {
    return /^[a-fA-F0-9]{24}$/.test(id);
  }

  function isNumberInRange(value) {
    return Number.isInteger(value) && value >= 10000 && value <= 20000;
  }

  const isConsecutiveSelectedOrSingle = useCallback(
    (sessionId) => {
      if (selectedPositions?.length === 1 || selectedPositions?.length === 0) {
        return true;
      }

      let isSequence = false;
      let lastSelectedIndex = -1;

      renderPositions
        ?.filter((item) => item?.session?._id === sessionId)
        ?.every((item, index) => {
          if (selectedPositions?.includes(item?._id)) {
            if (lastSelectedIndex === -1 || index === lastSelectedIndex + 1) {
              isSequence = true;
            } else {
              isSequence = false;
              return false;
            }
            lastSelectedIndex = index;
            return true;
          } else {
            return true;
          }
        });

      return isSequence;
    },
    [renderPositions, selectedPositions],
  );

  const updatedPositions = useCallback(
    ({ oldIds, isAutoSave }) => {
      if (updatedPositionsIds?.length === 0 && !deletedPositionIds) {
        dispatch(
          alertDialogAciton({
            open: true,
            title: "No changes detected",
            message: "No changes are made to be updated.",
          }),
        );
        return;
      }
      setIsBtnLoading(true);

      let addList = [];
      const params = {
        eventId: eventInfo?._id,
      };
      let payload = values?.positions?.reduce((acc, item) => {
        if (updatedPositionsIds?.includes(item?._id)) {
          // eslint-disable-next-line
          const { session, ...restItem } = item;
          const value = item?._id;
          const timeInAndOut = timeInAndTimeOutFromStartDate(
            item,
            item?.startDate,
          );
          if (typeof value === "string" && isValidMongoObjectId(value)) {
            acc.push({
              ...restItem,
              // sessionId: session?._id,
              sessionId: item?.session?._id,
              id: item?._id ?? item?.id,
              timeIn: !isTimeTBD(item?.timeIn)
                ? convertFromGivenTimezoneToUTC({
                    date: timeInAndOut?.timeIn,
                    timezone: eventInfo?.eventTimezone,
                  })
                : "TBD",
              timeOut: !isTimeTBD(item?.timeOut)
                ? convertFromGivenTimezoneToUTC({
                    date: timeInAndOut.timeOut,
                    timezone: eventInfo?.eventTimezone,
                  })
                : "TBD",
            });
          } else if (typeof value === "number" && isNumberInRange(value)) {
            addList.push({
              ...restItem,
              // sessionId: session?._id,
              sessionId: item?.session?._id,
              id: item?._id ?? item?.id,
              timeIn: !isTimeTBD(item?.timeIn)
                ? convertFromGivenTimezoneToUTC({
                    date: timeInAndOut?.timeIn,
                    timezone: eventInfo?.eventTimezone,
                  })
                : "TBD",
              timeOut: !isTimeTBD(item?.timeOut)
                ? convertFromGivenTimezoneToUTC({
                    date: timeInAndOut?.timeOut,
                    timezone: eventInfo?.eventTimezone,
                  })
                : "TBD",
            });
          }
        }
        return acc;
      }, []);

      // NOTE: do the add api call for it. and sync loader after both of these operation complete
      setIsBtnLoading(true);

      const promises = [];
      let message = "";
      let title = "";

      if (payload?.length > 0) {
        rememberPositionsToNotify(payload);
        promises.push(
          dispatch(
            updateMultiplePositionsOfMultipleSessionsAction({
              params,
              eventInfo,
              // Never emails on save; who to notify is asked when the sheet closes.
              payload: { positions: payload, notifyAssignedContractors: false },
              editLogPayload: isAutoSave
                ? null
                : {
                    description: `${payload?.map((position) => position?.positionName)?.join(", ")} position(s) ${payload?.length > 1 ? " are " : " is "} edited.`,
                    positionIds: payload?.map((pos) => pos?._id),
                    extraValues: { editingMultiplePositions: true },
                  },
              successCallback: isAutoSave
                ? null
                : (res) => {
                    message =
                      res?.response?.data?.message ||
                      "Position updated successfully";
                    title = "Positions Updated";
                  },
              failureCallback: isAutoSave
                ? null
                : (err) => {
                    message =
                      err?.error?.response?.data?.message ||
                      "Failed to updated positions";
                    title = "Error";
                  },
            }),
          ),
        );
      }

      if (addList?.length > 0) {
        promises.push(
          dispatch(
            addMultiplePositionsOfMultipleSessionsAction({
              params,
              eventInfo,
              payload: { positions: addList },
              addLogPayload: isAutoSave
                ? null
                : {
                    description: `${addList?.map((position) => position?.positionName)?.join(", ")} position(s) ${addList?.length > 1 ? " are " : " is "} added.`,
                    positionIds: addList?.map((pos) => pos?._id),
                    extraValues: { editingMultiplePositions: true },
                  },
              successCallback: (res) => {
                if (!isAutoSave) {
                  message += `${message ? "<br />" : ""} ${res?.response?.data?.message}`;
                  title = "Positions Updated";
                }
                updateNewAddedIds(res?.response?.data?.data, addList);
              },
              failureCallback: isAutoSave
                ? null
                : (error) => {
                    message += `${message ? "<br />" : ""} ${error?.error?.response?.data?.message}`;
                    title = "Error";
                  },
            }),
          ),
        );
      }

      if (deletedPositionIds && isEditMultiple) {
        let dPayload = [];
        Object?.keys(deletedPositionIds)?.forEach((sessionId) => {
          deletedPositionIds?.[sessionId]?.forEach((pos) => {
            dPayload?.push({
              sessionId: sessionId,
              id: pos,
            });
          });
        });

        promises?.push(
          dispatch(
            deleteMultiplePositionAction({
              payload: {
                positions: dPayload,
              },
              params: {
                eventId: eventInfo?._id,
              },
              stopAutoSave: () => {
                setPause(true);
              },
              onResumeAutoSave: (list) => {
                const rowsToInser = deletePositionsDetails?.filter((i) =>
                  list?.includes(i?._id),
                );
                handleInsertDirect(rowsToInser);
                setDeletedPositionsIds(null);
                setPause(false);
              },
              successCallback: isAutoSave
                ? () => {
                    setDeletedPositionsIds(null);
                    setPause(false);
                  }
                : (res) => {
                    dispatch(
                      addLogAction({
                        id: eventInfo?._id,
                        payload: {
                          positionids: dPayload.map((item) => item.id),
                          actionById: auth?.userId,
                          description: `${Object.entries(
                            deletePositionsDetails?.reduce((acc, pos) => {
                              const name = pos?.positionName;
                              acc[name] = (acc[name] || 0) + 1;
                              return acc;
                            }, {}),
                          )
                            .map(([name, count]) => `${name} * ${count}`)
                            .join(
                              ", ",
                            )} position(s) ${deletePositionsDetails?.length > 1 ? "are" : "is"} deleted.`,
                        },
                      }),
                    );
                    setDeletedPositionsIds(null);
                    setDeletedPositionsDetails(null);
                    message += `${message ? "<br />" : ""} ${res?.response?.data?.message || "Positions deleted successfully"}`;
                    title = "Positions Updated";

                    setPause(false);
                  },
              failureCallback: isAutoSave
                ? null
                : (error) => {
                    message += `${message ? "<br />" : ""} ${error?.error?.response?.data?.message || "Failed to delete positions"}`;
                    title = "Error";
                    setPause(false);
                  },
            }),
          ),
        );
      }

      trackSave(Promise.all(promises))
        .then(() => {
          if (title != "Error") {
            // TODO: do this after we click close button
            if (!isAutoSave) {
              if (eventInfo?.submitted) {
                dispatch(refreshPositionAction({ eventId: eventInfo?._id }));
              } else {
                dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
              }
              dispatch(
                alertDialogAciton({
                  open: true,
                  title,
                  message,
                }),
              );
            }
          } else {
            if (!isAutoSave) {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title,
                  message,
                }),
              );
            } else {
              // NOTE: failed to save data, update ids as old ids and show save button
              setUpdatedPositionsIds((prev) => [...prev, ...oldIds]);
              setShowSave(true);
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Error",
                  message: "Unable to auto save please do a manual save",
                }),
              );
            }
          }
        })
        .finally(() => {
          setIsBtnLoading(false);
          setShowSave(false);
          if (!isAutoSave) {
            setUpdatedPositionsIds([]);
            if (isEditMultiple) {
              handleClose();
            }
          }
        });
    },
    [
      dispatch,
      eventInfo,
      updatedPositionsIds,
      values,
      handleClose,
      rememberPositionsToNotify,
      trackSave,
      isEditMultiple,
      deletedPositionIds,
      deletePositionsDetails,
      // handleInsertDirect,
    ],
  );

  const deletePositionFromSession = useCallback(
    (positionData) => {
      const payload = {
        positionId: positionData?.positionId,
        id: positionData?._id,
      };
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Delete Position",
          message: "Are you sure, you want to delete this positions?",
          okLabel: "Delete",
          onOk: () => {
            setIsDelBtnLoading(true);
            dispatch(
              deletePositionAction({
                sessionId: session?._id,
                position: positionData,
                eventInfo,
                payload,
                auth,
                successCallback: () => {
                  if (eventInfo?.submitted) {
                    dispatch(
                      refreshPositionAction({ eventId: eventInfo?._id }),
                    );
                  } else {
                    dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
                  }
                  if (isEditMultiple) {
                    handleClose();
                  }
                  dispatch(
                    alertDialogAciton({
                      open: true,
                      title: "Success",
                      message: "Position deleted successfully.",
                    }),
                  );
                  setIsDelBtnLoading(false);
                },

                failureCallback: () => {
                  setIsDelBtnLoading(false);
                  dispatch(
                    alertDialogAciton({
                      open: true,
                      title: "Failure",
                      message: "Failed to delete position.",
                    }),
                  );
                },
              }),
            );
          },
        }),
      );
    },
    [dispatch, auth, eventInfo, session, handleClose, isEditMultiple],
  );

  const deleteSelectedPositions = useCallback(
    (sessionId) => {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Delete Positions",
          message: "Are you sure you want to delete selected positions?",
          okLabel: "Delete",
          onOk: () => {
            if (isManagePositions) {
              setValues((prev) => ({
                positions: prev?.positions?.filter((item) => {
                  return !selectedPositions?.includes(item?._id);
                }),
              }));
            } else {
              setIsDelBtnLoading(true);
              const params = {
                eventId: eventInfo?._id,
              };
              const payload = selectedPositions
                ?.filter((item) =>
                  getSessionPositions?.[sessionId]?.includes(item),
                )
                ?.map((item) => ({
                  id: item,
                  sessionId: session?._id,
                }));
              dispatch(
                deleteMultiplePositionAction({
                  payload: {
                    positions: payload,
                  },
                  params,
                  afterCallback: () => {
                    setIsDelBtnLoading(false);
                  },
                  failureCallback: () => {
                    dispatch(
                      alertDialogAciton({
                        open: true,
                        title: "Error",
                        message: "Failed to delete selected positions.",
                      }),
                    );
                  },
                  successCallback: () => {
                    if (eventInfo?.submitted) {
                      dispatch(
                        refreshPositionAction({ eventId: eventInfo?._id }),
                      );
                    } else {
                      dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
                    }
                    if (isEditMultiple) {
                      handleClose();
                    }
                    setSelectedPositions([]);
                    setIsDelBtnLoading(false);
                    dispatch(
                      alertDialogAciton({
                        open: true,
                        title: "Success",
                        message: "Selected positions deleted successfully.",
                      }),
                    );
                  },
                }),
              );
            }
          },
        }),
      );
    },
    [
      dispatch,
      selectedPositions,
      eventInfo,
      session,
      handleClose,
      isManagePositions,
      isEditMultiple,
      setValues,
      getSessionPositions,
    ],
  );

  const dateArrowClickHandler = useCallback((isCollapsed, sessionId, date) => {
    setCollapseDate((prev) => {
      return {
        ...prev,
        [sessionId]: isCollapsed
          ? prev?.[sessionId]?.filter((item) => item !== date)
          : [...(prev?.[sessionId] || []), date],
      };
    });
  }, []);

  // NOTE: delete for edit
  const deleteMultiplePositionsForEdit = useCallback(
    (data, Ids) => {
      setDeletedPositionsIds((prev) => {
        const newData = { ...(prev || {}) };
        Object.keys(data || {}).forEach((sessionId) => {
          newData[sessionId] = [
            ...(prev?.[sessionId] || []),
            ...(data?.[sessionId] || []).filter((value) => {
              return typeof value === "string" && isValidMongoObjectId(value);
            }),
          ];
        });
        return newData;
      });

      // NOTE: remove from values
      let deletedData = [];
      setValues((prev) => ({
        positions: prev?.positions?.filter((item) => {
          const result = !Ids?.includes(item?._id);
          if (!result) {
            deletedData?.push(item);
          }
          return result;
        }),
      }));
      setSelectedPositions((prev) =>
        prev?.filter((item) => !Ids?.includes(item)),
      );
      setDeletedPositionsDetails((prev) => [...(prev || []), ...deletedData]);
    },
    [setDeletedPositionsIds, setValues, setDeletedPositionsDetails],
  );

  const generateLogsBeforeClosing = useCallback(() => {
    const fieldsToCompare = [
      "startDate",
      "timeIn",
      "timeOut",
      "numberOfHours",
      "overNightShift",
      "selectOption",
      "complexity",
      "attire",
      "additionalComments",
    ];

    const oldMap = _.keyBy(data, "_id");

    const changedItems = _.compact(
      _.map(values?.positions, (newItem) => {
        const oldItem = oldMap[newItem._id];
        if (!oldItem) return null;

        const changes = _.reduce(
          fieldsToCompare,
          (acc, field) => {
            if (!_.isEqual(oldItem[field], newItem[field])) {
              acc.previousValues[field] = oldItem[field];
              acc.updatedValues[field] = newItem[field];
            }
            return acc;
          },
          { previousValues: {}, updatedValues: {} },
        );

        if (_.isEmpty(changes.previousValues)) return null;

        return {
          _id: newItem._id,
          positionName: newItem.positionName,
          quantity: newItem.quantity || 1,
          ...changes,
        };
      }),
    );

    if (changedItems.length) {
      const grouped = _.groupBy(changedItems, "positionName");
      const description =
        Object.entries(grouped)
          .map(([position, list]) => {
            const total = _.sumBy(list, "quantity");
            return total > 1 ? `${total} * ${position}` : position;
          })
          .join(", ") + " position(s) were edited";

      dispatch(
        addEditLogAction({
          id: eventInfo?._id,
          payload: {
            actionById: auth?.userId,
            positionIds: changedItems?.map((item) => item?._id),
            description,
            previousValues: changedItems?.map((item) => item?.previousValues),
            updatedValues: changedItems?.map((item) => item?.updatedValues),
          },
        }),
      );
    }
  }, [data, values?.positions, auth?.userId, dispatch, eventInfo?._id]);

  function getDatePosName(pos) {
    const timeIn = isTimeTBD(pos?.timeIn)
      ? pos?.timeIn
      : dayjs(pos?.timeIn).format("HH:mm");
    const timeOut = isTimeTBD(pos?.timeOut)
      ? pos?.timeOut
      : dayjs(pos?.timeOut).format("HH:mm");
    return `${pos?.startDate}-${pos?.positionName}-${timeIn}-${timeOut}-${!isTimeTBD(pos?.timeIn) ? 0 : (pos?.numberOfHours ?? 0)}-${pos?.overNightShift ? "yes" : "no"}`;
  }

  function generateSuffixFor(pos) {
    return `${pos?.startDate}-${pos?.positionName}`;
  }

  // callbacks end

  const handleContextMenu = (event, value, field, id, sessionId) => {
    event.preventDefault();
    setContextMenu({
      status: true,
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      value,
      field,
      id,
      sessionId,
    });
  };

  const addPositionToUpdatedList = (id) => {
    if (!updatedPositionsIds?.includes(id)) {
      setUpdatedPositionsIds((prev) => [...prev, id]);
    }
  };

  const addMultiplePositionsToUpdatedList = (ids) => {
    setUpdatedPositionsIds((prev) => {
      return [
        ...(prev || []),
        ...(ids?.filter((id) => !prev?.includes(id)) || []),
      ];
    });
  };

  const doesSessionHavePositionsHandler = ({ session }) => {
    return renderPositions?.find?.((position) => {
      return position?.session?._id === session?._id;
    });
  };

  function closeSessionSelection() {
    setSessionSelection((prev) => ({ ...prev, status: false }));
  }

  // Latest rows, read by updateNewAddedIds (it runs after an async request).
  const valuesRef = useRef(values);
  valuesRef.current = values;

  // Swaps the temporary ids of freshly added rows for the real ids the server
  // returned. Each created shift is matched once, by session + position, in order,
  // so copies of the same position never end up sharing an id.
  const updateNewAddedIds = useCallback(
    (responseList, addList) => {
      const pending = [...(Array.isArray(responseList) ? responseList : [])];
      const idMap = new Map();
      const sessionOfTempId = new Map();

      addList?.forEach((item) => {
        const idx = pending.findIndex(
          (li) =>
            String(li?.positionId) === String(item?.positionId) &&
            String(li?.sessionId) === String(item?.sessionId),
        );
        if (idx === -1) return;
        idMap.set(item?.id, pending[idx]?._id);
        sessionOfTempId.set(item?.id, item?.sessionId);
        pending.splice(idx, 1);
      });

      if (idMap.size === 0) return;

      const stillOnScreen = new Set(
        (valuesRef.current?.positions || []).map((row) => row?._id),
      );

      setValues((prev) => ({
        positions: prev?.positions?.map((row) =>
          idMap.has(row?._id) ? { ...row, _id: idMap.get(row?._id) } : row,
        ),
      }));

      // Edits made while the request was in flight still point at the old id.
      setUpdatedPositionsIds((prev) =>
        (prev || []).map((id) => (idMap.has(id) ? idMap.get(id) : id)),
      );

      // The row was deleted before the server answered: the shift now exists in the
      // database, so delete it there too (autosave sends deletedPositionIds).
      const orphans = [];
      idMap.forEach((realId, tempId) => {
        if (!stillOnScreen.has(tempId)) {
          orphans.push({ sessionId: sessionOfTempId.get(tempId), realId });
        }
      });
      if (orphans.length > 0) {
        setDeletedPositionsIds((prev) => {
          const next = { ...(prev || {}) };
          orphans.forEach(({ sessionId, realId }) => {
            next[sessionId] = [...(next[sessionId] || []), realId];
          });
          return next;
        });
      }
    },
    [setValues, setUpdatedPositionsIds, setDeletedPositionsIds],
  );

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      const timeSelectionWidget = document.getElementsByClassName(
        "MuiMultiSectionDigitalClockSection-root",
      );
      for (let i = 0; i < timeSelectionWidget?.length; i++) {
        if (timeSelectionWidget?.[i]?.classList?.add) {
          timeSelectionWidget[i]?.classList?.add("custom-scroll-design");
        }
      }
    }, 500);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  React.useEffect(() => {
    if (isBtnLoading) return;

    setValues({ positions: sortedPositions });
  }, [sortedPositions, setValues]);

  React.useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open, resetForm]);

  React.useEffect(() => {
    if (applyAllFilters) {
      const otherSessions = {};
      for (let i = 1; i < sessions?.length; i++) {
        otherSessions[sessions?.[i]?._id] = {
          ...filters?.[sessions?.[0]?._id],
        };
      }

      setFilters((filters) => {
        return {
          ...filters,
          ...otherSessions,
        };
      });
    }
  }, [filters[sessions?.[0]?._id]]);

  React.useEffect(() => {
    setCollapseAndExpandableData();
  }, [setCollapseAndExpandableData]);

  useEffect(() => {
    if (isManagePositions) return;
    if (updatedPositionsIds?.length == 0 && !deletedPositionIds) return;
    if (errors?.positions?.length > 0) return;
    const timeout = setTimeout(() => {
      const oldPositionIds = updatedPositionsIds;
      if (pause) return;
      updatedPositions({
        oldIds: oldPositionIds,
        isAutoSave: true,
      });
      setUpdatedPositionsIds([]);
      setDeletedPositionsIds(null);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [
    updatedPositionsIds,
    updatedPositions,
    deletedPositionIds,
    errors,
    isManagePositions,
    pause,
  ]);

  function alertBeforeCloseOnEdit() {
    if (errors?.positions?.length > 0 && !isManagePositions) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Warning",
          message:
            "There are still errors on the sheet, please fix those before quitting.",
          okLabel: "Quit Anyway",
          onOk: () => {
            handleClose();
          },
        }),
      );
      return;
    } else if (
      isManagePositions &&
      (updatedPositionsIds?.length > 0 || deletedPositionIds)
    ) {
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Warning",
          message: " Closing this popup window will reset all changes.",
          onOk: () => {
            handleClose();
          },
          okLabel: "Close popup",
          closeLabel: "Back",
        }),
      );

      return;
    }
    if (!isManagePositions) {
      generateLogsBeforeClosing();
    }
    if (eventInfo?.submitted) {
      dispatch(refreshPositionAction({ eventId: eventInfo?._id }));
    } else if (!isManagePositions) {
      dispatch(getSessionssOfSpecificEvent(eventInfo?._id));
    }
    handleClose();
  }

  return (
    <>
    <Modal
      open={open}
      onClose={alertBeforeCloseOnEdit}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box sx={{ position: "relative" }}>
        <Box
          sx={{
            ...style,
            // position: "relative",
            height: "95vh",
            width: "95vw",
            overflowY: "auto",
            minWidth: isMediumScreen ? "0" : "900px",
            "@media (max-width: 600px)": {
              // overflowY: "auto",
              maxHeight: "97vh",
            },
            "@media (max-width: 900px)": {
              overflowY: "auto",
            },
          }}
          // className="custom-scroll-design"
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              right: "0",
              transform: `translate(50%, -50%)`,
            }}
          >
            <GenericTransparentBtn
              onClick={() => {
                alertBeforeCloseOnEdit();
              }}
              style={{
                background: "grey",
                padding: "0.10rem",
                borderRadius: "50%",
                onHover: {
                  background: "grey",
                  padding: "0.10rem",
                },
              }}
              // disabled={searchText ? false : true}
            >
              <Close
                sx={{
                  fontSize: "2rem",
                  // marginRight: "0.7rem"
                }}
              />
            </GenericTransparentBtn>
          </Box>

          {(isBtnLoading || isDelBtnLoading) && showSave ? (
            <LoadingOverlay open={true} />
          ) : null}

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box
              sx={{
                display: "flex",
                position: "relative",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "1rem",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "1rem",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "32px",
                    fontWeight: "500",
                    textAlign: "center",
                    // marginBottom: "15px",
                  }}
                >
                  {isManagePositions
                    ? "Manage Positions"
                    : isEditMultiple
                      ? "Edit Positions"
                      : "Positions"}
                </Typography>

                {!isUnfoldAll ? (
                  <Button
                    sx={{
                      marginLeft: "10px",
                      background: getCssVariableHandler({
                        variableName: "--primary-pink-rgb",
                      }),
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "0.25rem 0.5rem",
                    }}
                    onClick={() => unfoldLessHandler(session?._id)}
                  >
                    <Typography>Group</Typography>
                  </Button>
                ) : (
                  <Button
                    sx={{
                      marginLeft: "10px",
                      background: getCssVariableHandler({
                        variableName: "--primary-pink-rgb",
                      }),
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "0.25rem 0.5rem",
                    }}
                    onClick={() => unfoldMoreHandler(session?._id)}
                  >
                    <Typography>Ungroup</Typography>
                  </Button>
                )}

                {!isManagePositions && eventInfo?.submitted ? (
                  <FormControlLabel
                    sx={{ marginLeft: "0.5rem" }}
                    control={
                      <Checkbox
                        checked={notifyTechnicians}
                        onChange={(e) => setNotifyTechnicians(e.target.checked)}
                        sx={{
                          color: getCssVariableHandler({ variableName: "--font-rgb" }),
                        }}
                      />
                    }
                    label="Notify assigned technicians about my changes when I close"
                  />
                ) : null}
              </Box>

              {isManagePositions && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  <Typography fontSize={"1rem"} mr={"0.25rem"}>
                    Help
                  </Typography>
                  <Tooltip title={"Get Help"} arrow placement="top">
                    <img
                      src={InfoImage}
                      style={{
                        height: "1rem",
                        width: "1rem",
                        cursor: "pointer",
                      }}
                    />
                  </Tooltip>
                  <CustomSwitch
                    sx={{
                      scale: "0.75",
                    }}
                    checked={helpStatus}
                    onClick={() => {
                      dispatch(toggleHelper(!helpStatus));
                    }}
                  />
                </Box>
              )}

              {!isManagePositions ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  {!showSave && isBtnLoading ? (
                    <CircularProgress size={24} />
                  ) : null}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <Typography fontSize={"1rem"} mr={"0.25rem"}>
                      Help
                    </Typography>
                    <Tooltip title={"Get Help"} arrow placement="top">
                      <img
                        src={InfoImage}
                        style={{
                          height: "1rem",
                          width: "1rem",
                          cursor: "pointer",
                        }}
                      />
                    </Tooltip>
                    <CustomSwitch
                      sx={{
                        scale: "0.75",
                      }}
                      checked={helpStatus}
                      onClick={() => {
                        dispatch(toggleHelper(!helpStatus));
                      }}
                    />
                  </Box>
                  {sessions?.length > 1 &&
                    !isEditMultiple &&
                    !isPositionBoard && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <GmailCheckbox
                          checked={applyAllFilters}
                          onChange={(e) => {
                            if (e?.target?.checked) {
                              setFilters((filters) => {
                                return {
                                  ...filters,
                                  [sessions?.[1]?._id]: {
                                    ...filters?.[sessions?.[0]?._id],
                                  },
                                };
                              });
                            }

                            setApplyAllFilters(e?.target?.checked);
                          }}
                        />
                        <Typography fontSize={"14px"}>
                          Apply Same Filters
                        </Typography>
                      </Box>
                    )}

                  {(!isManagePositions || isEditMultiple) &&
                    showSave &&
                    (updatedPositionsIds?.length > 0 || deletedPositionIds) && (
                      <Box sx={{ marginTop: "0px" }} className="bottom-btn-box">
                        <Button
                          className="btn-pink"
                          onClick={() => {
                            if (!formik.isValid) {
                              dispatch(
                                alertDialogAciton({
                                  open: true,
                                  title: "Alert",
                                  message:
                                    "Please resolve all the errors before saving changes.",
                                }),
                              );
                              return;
                            }
                            if (isManagePositions) {
                              submitForm();
                            } else {
                              updatedPositions({});
                            }
                          }}
                        >
                          <CustomHelper
                            isText={true}
                            top={isManagePositions ? "-0.75rem" : "-1.75rem"}
                            right={isManagePositions ? "-0.75rem" : "-4rem"}
                            message={
                              isManagePositions
                                ? "Add positions to session"
                                : "Update positions"
                            }
                          >
                            <Typography sx={{ fontSize: "1rem" }}>
                              {isManagePositions ? "Add Positions" : "Save"}
                            </Typography>
                          </CustomHelper>
                        </Button>
                      </Box>
                    )}
                  {!isEditMultiple && (
                    <CustomHelper
                      message={"View session list to add it on current view"}
                    >
                      <Button
                        // className={styles.BtnBlackPink}
                        sx={{
                          // position: "absolute",
                          top: "0",
                          right: "0",
                          textTransform: "capitalize !important",
                          minWidth: "100px !important",
                          fontSize: "16px !important",
                          borderRadius: "12px !important",
                          background: "#000000 !important",
                          border: "none !important",
                          padding: "16px 60px !important",
                          boxShadow: `0px 30px 80px 0px rgba(255, 0, 255, 0.3),
0px 0px 20px 0px #d85ad84f inset !important`,
                        }}
                        onClick={() => {
                          setSessionSelection((prev) => ({
                            ...prev,
                            status: true,
                          }));
                        }}
                      >
                        View Sessions
                      </Button>
                    </CustomHelper>
                  )}
                </Box>
              ) : null}
            </Box>

            <Grid
              item
              sx={{
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap:
                    isMediumScreen && !isManagePositions ? "1.5rem" : "0.5rem",
                  width: "100%",
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                  ...(isPositionBoard ? { height: "calc(90vh - 8rem)" } : {}),
                }}
              >
                {applyAllFilters && !isPositionBoard && (
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "1rem",
                      my: "0.5rem",
                    }}
                  >
                    {/* NOTE: search */}
                    <SheetSearchInput
                      fullWidth
                      value={filters?.["all"]?.searchStr}
                      onChange={(e) =>
                        setFilters((prev) => ({
                          ...prev,
                          ["all"]: {
                            ...prev?.["all"],
                            searchStr: e.target.value,
                            searchStrPrev: prev.searchStr,
                          },
                        }))
                      }
                      endAdornment={
                        <InputAdornment position="start">
                          {filters?.["all"]?.searchStr ? (
                            <GenericTransparentBtn
                              onClick={() => {
                                setFilters((prev) => ({
                                  ...prev,
                                  ["all"]: {
                                    ...prev?.["all"],
                                    searchStr: "",
                                    searchStrPrev: "",
                                  },
                                }));
                              }}
                              style={{
                                background: "grey",
                                padding: "0.10rem",
                                borderRadius: "50%",
                                onHover: {
                                  background: "grey",
                                  padding: "0.10rem",
                                },
                              }}
                            >
                              <Close
                                sx={{
                                  fontSize: "1rem",
                                  // marginRight: "0.7rem"
                                }}
                              />
                            </GenericTransparentBtn>
                          ) : null}
                        </InputAdornment>
                      }
                      placeholder="Search here"
                    />
                    {/* NOTE: filters */}

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: isSmallScreen ? "column" : "row",
                        alignItems: "center",
                        gap: "1rem",
                        marginRight: "10px",
                      }}
                    >
                      <SheetFilterDropdown
                        options={
                          getOptionsHandler(session?._id, true)?.positionOptions
                        }
                        setValue={(val) => {
                          setFilters((prev) => ({
                            ...prev,
                            ["all"]: {
                              ...prev?.["all"],
                              positionName: val,
                              positionNamePrev: prev.positionName,
                            },
                          }));
                        }}
                        placeholder={"Filter Positions"}
                        value={filters?.["all"]?.positionName}
                        valueText={"Positions"}
                        style={{
                          minWidth: "200px",
                        }}
                        onClear={() => {
                          setFilters((filters) => {
                            return {
                              ...filters,
                              ["all"]: {
                                ...(filters?.["all"] || {}),
                                positionName: [],
                                positionNamePrev: [],
                              },
                            };
                          });
                        }}
                      />

                      <SheetFilterDropdown
                        options={
                          getOptionsHandler(session?._id, true)
                            ?.startDateOptions
                        }
                        setValue={(val) => {
                          // setFilters((prev) => ({
                          //   ...prev,
                          //   startDate: val,
                          //   startDatePrev: prev?.startDate
                          // }));

                          setFilters((prev) => ({
                            ...prev,
                            ["all"]: {
                              ...prev?.["all"],
                              startDate: val,
                              startDatePrev: prev?.startDate,
                            },
                          }));
                        }}
                        placeholder={"Filter date"}
                        value={filters?.["all"]?.startDate}
                        valueText={"Date"}
                        style={{
                          minWidth: "180px",
                        }}
                        onClear={() => {
                          setFilters((filters) => {
                            return {
                              ...filters,
                              ["all"]: {
                                ...filters?.["all"],
                                startDate: [],
                                startDatePrev: [],
                              },
                            };
                          });
                        }}
                      />
                      {(filters?.["all"]?.startDate?.length > 0 ||
                        filters?.["all"]?.searchStr ||
                        filters?.["all"]?.positionName?.length > 0) && (
                        <Button
                          variant="contained"
                          sx={{
                            bgcolor: "white",
                            padding: "0.25rem 0.5rem",
                            minWidth: "auto",
                            "&:hover": {
                              bgcolor: "rgba(255,255,255,0.75) !important",
                            },
                          }}
                          onClick={() => {
                            setFilters(filtersInitialValue);
                          }}
                        >
                          <Typography
                            sx={{
                              color: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                              whiteSpace: "nowrap",
                            }}
                          >
                            Clear all filters
                          </Typography>
                        </Button>
                      )}
                    </Box>
                  </Box>
                )}
                {sessions?.map((session, sessionIdx) => {
                  return (
                    <Box
                      key={`session-${sessionIdx}`}
                      sx={{
                        width: isManagePositions
                          ? "100%"
                          : sessions?.length === 1
                            ? "100%"
                            : isMediumScreen
                              ? "100%"
                              : "49.25%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                      }}
                    >
                      {/* NOTE: search bar and filters */}
                      {!applyAllFilters && !isPositionBoard && (
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "space-between",
                            gap: "0.45rem",
                            marginTop: "0.5rem",
                          }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              // justifyContent: "flex-start",
                              justifyContent:
                                sessions?.length === 1
                                  ? "space-between"
                                  : "space-between",
                              alignItems: "center",
                              gap: "1rem",
                            }}
                          >
                            {!isManagePositions ? (
                              <SheetSearchInput
                                fullWidth
                                value={filters?.[session?._id]?.searchStr}
                                onChange={(e) =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    [session?._id]: {
                                      ...prev?.[session?._id],
                                      searchStr: e.target.value,
                                      searchStrPrev: prev.searchStr,
                                    },
                                  }))
                                }
                                endAdornment={
                                  <InputAdornment position="start">
                                    {filters?.[session?._id]?.searchStr ? (
                                      <GenericTransparentBtn
                                        onClick={() => {
                                          setFilters((prev) => ({
                                            ...prev,
                                            [session?._id]: {
                                              ...prev?.[session?._id],
                                              searchStr: "",
                                              searchStrPrev: "",
                                            },
                                          }));
                                        }}
                                        style={{
                                          background: "grey",
                                          padding: "0.10rem",
                                          borderRadius: "50%",
                                          onHover: {
                                            background: "grey",
                                            padding: "0.10rem",
                                          },
                                        }}
                                      >
                                        <Close
                                          sx={{
                                            fontSize: "1rem",
                                            // marginRight: "0.7rem"
                                          }}
                                        />
                                      </GenericTransparentBtn>
                                    ) : null}
                                  </InputAdornment>
                                }
                                placeholder="Search here"
                              />
                            ) : null}

                            <Box
                              sx={{
                                ...(isManagePositions
                                  ? {
                                      width: "100%",
                                    }
                                  : {}),
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: !isManagePositions
                                  ? "flex-end"
                                  : "space-between",
                                alignItems: "center",
                                gap: "1rem",
                                // marginBottom: "1rem",
                              }}
                            >
                              {isManagePositions ? (
                                <SheetSearchInput
                                  sx={{ flexGrow: "1" }}
                                  value={filters?.[session?._id]?.searchStr}
                                  onChange={(e) =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      [session?._id]: {
                                        ...prev?.[session?._id],
                                        searchStr: e.target.value,
                                        searchStrPrev: prev.searchStr,
                                      },
                                    }))
                                  }
                                  endAdornment={
                                    <InputAdornment position="start">
                                      {filters?.[session?._id]?.searchStr ? (
                                        <GenericTransparentBtn
                                          onClick={() => {
                                            setFilters((prev) => ({
                                              ...prev,
                                              [session?._id]: {
                                                ...prev?.[session?._id],
                                                searchStr: "",
                                                searchStrPrev: "",
                                              },
                                            }));
                                          }}
                                          style={{
                                            background: "grey",
                                            padding: "0.10rem",
                                            borderRadius: "50%",
                                            onHover: {
                                              background: "grey",
                                              padding: "0.10rem",
                                            },
                                          }}
                                        >
                                          <Close
                                            sx={{
                                              fontSize: "1rem",
                                              // marginRight: "0.7rem"
                                            }}
                                          />
                                        </GenericTransparentBtn>
                                      ) : null}
                                    </InputAdornment>
                                  }
                                  placeholder="Search here"
                                />
                              ) : selectedPositions?.length > 1 ? (
                                <></>
                              ) : null}

                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: isSmallScreen
                                    ? "column"
                                    : "row",
                                  alignItems: "center",
                                  gap: "1rem",
                                  marginRight: "10px",
                                  // flexWrap: "wrap",
                                }}
                              >
                                {/* NOTE: filters */}

                                <SheetFilterDropdown
                                  options={getOptionsHandler(
                                    session?._id,
                                  )?.positionOptions?.filter(
                                    (item) => item?.sessionId === session?._id,
                                  )}
                                  setValue={(val) => {
                                    // setFilters((prev) => ({
                                    //   ...prev,
                                    //   positionName: val,
                                    //   positionNamePrev: prev.positionName
                                    // }));

                                    setFilters((prev) => ({
                                      ...prev,
                                      [session?._id]: {
                                        ...prev?.[session?._id],
                                        positionName: val,
                                        positionNamePrev: prev.positionName,
                                      },
                                    }));
                                  }}
                                  placeholder={"Filter Positions"}
                                  value={filters?.[session?._id]?.positionName}
                                  valueText={"Positions"}
                                  style={{
                                    minWidth: "200px",
                                  }}
                                  onClear={() => {
                                    setFilters((filters) => {
                                      return {
                                        ...filters,
                                        [session?._id]: {
                                          ...(filters?.[session?._id] || {}),
                                          positionName: [],
                                          positionNamePrev: [],
                                        },
                                      };
                                    });
                                  }}
                                />

                                <SheetFilterDropdown
                                  options={getOptionsHandler(
                                    session?._id,
                                  )?.startDateOptions?.filter(
                                    (item) => item?.sessionId === session?._id,
                                  )}
                                  setValue={(val) => {
                                    // setFilters((prev) => ({
                                    //   ...prev,
                                    //   startDate: val,
                                    //   startDatePrev: prev?.startDate
                                    // }));

                                    setFilters((prev) => ({
                                      ...prev,
                                      [session?._id]: {
                                        ...prev?.[session?._id],
                                        startDate: val,
                                        startDatePrev: prev?.startDate,
                                      },
                                    }));
                                  }}
                                  placeholder={"Filter date"}
                                  value={filters?.[session?._id]?.startDate}
                                  valueText={"Date"}
                                  style={{
                                    minWidth: "180px",
                                  }}
                                  onClear={() => {
                                    setFilters((filters) => {
                                      return {
                                        ...filters,
                                        [session?._id]: {
                                          ...filters?.[session?._id],
                                          startDate: [],
                                          startDatePrev: [],
                                        },
                                      };
                                    });
                                  }}
                                />
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      )}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-end",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "1.20rem",
                            fontWeight: "500",
                          }}
                        >
                          Session:{" "}
                          <Typography
                            sx={{
                              display: "inline",
                              fontWeight: "300",
                              fontSize: "1.20rem",
                              textWrap: "wrap",
                            }}
                          >
                            {session?.sessionName}
                            {isPositionBoard
                              ? `(${getUniversalDateTimeFormat({ dateTime: session?.sessionStart })} - ${getUniversalDateTimeFormat({ dateTime: session?.sessionEnd })})`
                              : ""}
                          </Typography>
                        </Typography>

                        <Box>
                          <Box sx={{ marginRight: "10px" }}>
                            {isManagePositions ? (
                              <Button
                                sx={{
                                  minWidth: "0",
                                  // width: "8rem !important",
                                  padding: "0.25rem 0.85rem",
                                  // height: " !important",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => {
                                  if (!formik.isValid) {
                                    dispatch(
                                      alertDialogAciton({
                                        open: true,
                                        title: "Alert",
                                        message:
                                          "Please resolve all the errors before saving changes.",
                                      }),
                                    );
                                    return;
                                  }
                                  if (isManagePositions) {
                                    submitForm();
                                  } else {
                                    updatedPositions({});
                                  }
                                }}
                              >
                                <CustomHelper
                                  isText={true}
                                  top={"-0.85rem"}
                                  right={"-1rem"}
                                  message={
                                    isManagePositions
                                      ? "Add positions to session"
                                      : "Update positions"
                                  }
                                >
                                  <Typography sx={{ fontSize: "1rem" }}>
                                    {isManagePositions
                                      ? "Add Positions"
                                      : "Save"}
                                  </Typography>
                                </CustomHelper>
                              </Button>
                            ) : null}

                            {(!isManagePositions &&
                              doesSelectedPositionIncludes(session?._id)) ||
                            (isManagePositions &&
                              selectedPositions?.length > 1) ? (
                              <Button
                                sx={{
                                  marginLeft: "10px",
                                  // border: "1px solid #FFF",
                                  background: getCssVariableHandler({
                                    variableName: "--primary-pink-rgb",
                                  }),
                                  boxShadow:
                                    "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                                  minWidth: "auto",
                                  padding: "0.25rem 0.5rem",
                                }}
                                onClick={() => {
                                  if (isEditMultiple) {
                                    deleteMultiplePositionsForEdit(
                                      {
                                        [session?._id]: selectedPositions,
                                      },
                                      selectedPositions,
                                    );
                                    return;
                                  }
                                  deleteSelectedPositions(session?._id);
                                }}
                              >
                                <CustomHelper
                                  isText={true}
                                  top={"-0.85rem"}
                                  right={"-1rem"}
                                  message={
                                    isManagePositions
                                      ? "Add positions to session"
                                      : "Update positions"
                                  }
                                >
                                  <Typography sx={{ fontSize: "1rem" }}>
                                    Delete Selected
                                  </Typography>
                                </CustomHelper>
                              </Button>
                            ) : null}
                          </Box>

                          {(filters?.[session?._id]?.startDate?.length > 0 ||
                            filters?.[session?._id]?.searchStr ||
                            filters?.[session?._id]?.positionName?.length >
                              0) &&
                            !applyAllFilters && (
                              <Button
                                variant="contained"
                                sx={{
                                  bgcolor: "white",
                                  padding: "0.25rem 0.5rem",
                                  minWidth: "auto",
                                  "&:hover": {
                                    bgcolor:
                                      "rgba(255,255,255,0.75) !important",
                                  },
                                }}
                                onClick={() => {
                                  setFilters((prev) => ({
                                    ...prev,
                                    [session?._id]: null,
                                  }));
                                }}
                              >
                                <Typography
                                  sx={{
                                    color: getCssVariableHandler({
                                      variableName: "--primary-pink-hex",
                                    }),
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Clear all filters
                                </Typography>
                              </Button>
                            )}
                        </Box>
                      </Box>
                      <TableContainer
                        className="custom-scroll-design"
                        sx={{
                          borderRadius: "0.5rem",
                          width: "100%",
                          maxWidth: "auto",
                          maxHeight: isSmallScreen
                            ? "calc(80vh - 13rem)"
                            : isPositionBoard
                              ? sessions?.length > 2
                                ? "35vh"
                                : "calc(80vh - 11rem)"
                              : isManagePositions
                                ? "81vh"
                                : "calc(80vh - 10rem)",
                          overflowX: "auto",
                        }}
                      >
                        <StyledTable stickyHeader>
                          <TableHead>
                            <StyledTableHeadRow>
                              <StyledTableCell
                                sx={{
                                  paddingLeft: "1rem !important",
                                  textAlign: "left !important",
                                }}
                              >
                                <GmailCheckbox
                                  fillColor={"white"}
                                  checked={
                                    isManagePositions
                                      ? selectedPositions?.length ==
                                        values?.positions?.length
                                      : getSessionPositions?.[
                                          session?._id
                                        ]?.every((posId) =>
                                          selectedPositions?.includes(posId),
                                        )
                                  }
                                  indeterminate={
                                    isManagePositions
                                      ? selectedPositions?.length == 0
                                        ? false
                                        : selectedPositions?.length <
                                          values?.positions?.length
                                      : getSessionPositions?.[
                                          session?._id
                                        ]?.some((posId) =>
                                          selectedPositions?.includes(posId),
                                        ) &&
                                        !getSessionPositions?.[
                                          session?._id
                                        ]?.every((posId) =>
                                          selectedPositions?.includes(posId),
                                        )
                                  }
                                  onChange={() => {
                                    headerCheckBoxClickAction(session?._id);
                                  }}
                                />
                                Sr No.
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ paddingLeft: "1.5rem !important" }}
                              >
                                Start Date
                                <TableSortLabel
                                  sx={{
                                    padding: "0",
                                    paddingLeft: "0.25rem",
                                    textWrap: "nowrap",
                                  }}
                                  active={true}
                                  direction={
                                    sorting?.dateStart === "asc"
                                      ? "desc"
                                      : "asc"
                                  }
                                  onClick={() => {
                                    setSorting((sorting) => {
                                      return {
                                        ...sorting,
                                        dateStart:
                                          sorting?.dateStart === "asc"
                                            ? "desc"
                                            : "asc",
                                        fieldChange: "dateStart",
                                      };
                                    });
                                  }}
                                  IconComponent={(props) => (
                                    <IconButton
                                      sx={{ paddingLeft: "0", marginLeft: "0" }}
                                      {...props}
                                    >
                                      <Icon>{<img src={SortArrow} />}</Icon>
                                    </IconButton>
                                  )}
                                />
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ paddingLeft: "1.5rem !important" }}
                              >
                                Position Name
                                <TableSortLabel
                                  sx={{
                                    padding: "0",
                                    paddingLeft: "0.25rem",
                                    textWrap: "nowrap",
                                  }}
                                  active={true}
                                  direction={
                                    sorting?.positionName === "asc"
                                      ? "desc"
                                      : "asc"
                                  }
                                  onClick={() => {
                                    setSorting((sorting) => {
                                      return {
                                        ...sorting,
                                        positionName:
                                          sorting?.positionName === "asc"
                                            ? "desc"
                                            : "asc",
                                        fieldChange: "positionName",
                                      };
                                    });
                                  }}
                                  IconComponent={(props) => (
                                    <IconButton
                                      sx={{ paddingLeft: "0", marginLeft: "0" }}
                                      {...props}
                                    >
                                      <Icon>{<img src={SortArrow} />}</Icon>
                                    </IconButton>
                                  )}
                                />
                              </StyledTableCell>
                              <StyledTableCell>Quantity</StyledTableCell>
                              <StyledTableCell>Time In</StyledTableCell>
                              <StyledTableCell>Time Out</StyledTableCell>
                              <StyledTableCell>No. Of Hours</StyledTableCell>
                              <StyledTableCell>Overnight</StyledTableCell>
                              <StyledTableCell>Meal Options</StyledTableCell>
                              <StyledTableCell>Complexity</StyledTableCell>
                              <StyledTableCell>Attire</StyledTableCell>
                              <StyledTableCell>Comments</StyledTableCell>
                              {!hideDelete && (
                                <StyledTableCell></StyledTableCell>
                              )}
                            </StyledTableHeadRow>
                          </TableHead>
                          <TableBody>
                            {!doesSessionHavePositionsHandler({
                              session,
                            }) ? (
                              <TableRow key={`no-data-row`}>
                                <StyledTableCell
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: "1rem !important",
                                    textAlign: "center",
                                  }}
                                  colSpan={20}
                                >
                                  No Positions Found
                                </StyledTableCell>
                              </TableRow>
                            ) : (
                              renderPositions
                                ?.filter?.((item) => {
                                  return item?.session?._id === session?._id;
                                })
                                ?.map((item, itemIdx) => {
                                  // it is to check if the current line and the next line's date match
                                  if (itemIdx > values?.positions?.length - 1)
                                    return null;
                                  // const previousDate =
                                  //   renderPositions?.[itemIdx - 1]?.startDate;

                                  const isMatch =
                                    item?.startDate === previousRowDate;
                                  previousRowDate = item?.startDate;
                                  const isSelected =
                                    selectedPositions?.includes(item?._id);
                                  const errorsHere =
                                    positionErrorMap?.[item?._id] || {};

                                  // NOTE: collapse and expand code
                                  const dpName = getDatePosName(item);
                                  const {
                                    startIdx,
                                    endIdx,
                                    count,
                                    status,
                                    ids: Ids,
                                  } = dateChangedIdx?.[session?._id]?.[
                                    dpName
                                  ] || {};
                                  const indeterminateStatus =
                                    isIndeterminateOnCollapse(Ids);
                                  const collapsedSelectedAll =
                                    isAllSelected(Ids);

                                  const isDateCollapsed = collapseDate?.[
                                    session?._id
                                  ]?.includes(item?.startDate);

                                  if (
                                    status &&
                                    itemIdx > startIdx &&
                                    itemIdx <= endIdx
                                  ) {
                                    return null;
                                  }
                                  return (
                                    <>
                                      {!isMatch || itemIdx == 0 ? (
                                        <TableRow
                                          key={`${itemIdx} ${item?.startDate}`}
                                        >
                                          <StyledTableCell
                                            sx={{
                                              fontWeight: 600,
                                              fontSize: "1rem !important",
                                              backgroundColor:
                                                "#e5e5e578 !important",
                                              textAlign: "left !important",
                                              paddingLeft: "1rem !important",
                                            }}
                                            colSpan={20}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "0.5rem",
                                              }}
                                            >
                                              <GenericTransparentBtn
                                                onClick={() => {
                                                  dateArrowClickHandler(
                                                    isDateCollapsed,
                                                    session?._id,
                                                    item?.startDate,
                                                  );
                                                }}
                                              >
                                                {isDateCollapsed ? (
                                                  <KeyboardArrowRight />
                                                ) : (
                                                  <KeyboardArrowDown />
                                                )}
                                              </GenericTransparentBtn>
                                              {dayjs(item?.startDate).format(
                                                "ddd MM/DD/YYYY",
                                              )}
                                            </Box>
                                          </StyledTableCell>
                                        </TableRow>
                                      ) : null}
                                      {isDateCollapsed ? null : (
                                        <StyledTableRow
                                          index={itemIdx}
                                          sx={{
                                            ...(isSelected
                                              ? {
                                                  backgroundColor:
                                                    "#D175B6a1 !important",
                                                }
                                              : {}),
                                          }}
                                          key={item?._id}
                                        >
                                          <StyledTableCell
                                            sx={{
                                              textAlign: "left !important",
                                              paddingLeft: "1rem !important",
                                            }}
                                            onContextMenu={(e) => {
                                              e.preventDefault();
                                              setCheckBoxContextMenu({
                                                status: true,
                                                mouseX: e.clientX + 2,
                                                mouseY: e.clientY - 6,
                                                collapsed: {
                                                  status,
                                                  Ids,
                                                  isSelected,
                                                },
                                                id: item?._id,
                                                sessionId: session?._id,
                                                type:
                                                  copiedRows?.length === 0
                                                    ? "COPY"
                                                    : "PASTE",
                                              });
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                alignItems: "center",
                                                gap: "0.5rem",
                                              }}
                                            >
                                              <GmailCheckbox
                                                checked={
                                                  status
                                                    ? collapsedSelectedAll
                                                    : isSelected
                                                }
                                                indeterminate={
                                                  status
                                                    ? indeterminateStatus
                                                    : false
                                                }
                                                onChange={() => {
                                                  if (status) {
                                                    positionCheckBoxCollapsedClickAction(
                                                      Ids,
                                                      collapsedSelectedAll,
                                                      indeterminateStatus,
                                                    );
                                                  } else {
                                                    positionCheckBoxClickAction(
                                                      item?._id,
                                                    );
                                                  }
                                                }}
                                              />
                                              {itemIdx + 1}
                                              {startIdx === itemIdx ? (
                                                status ? (
                                                  <CustomIconButtonForSheet
                                                    sx={{}}
                                                    onClick={() => {
                                                      setDateChangedIdx(
                                                        (prev) => ({
                                                          ...prev,
                                                          [session?._id]: {
                                                            ...(prev?.[
                                                              session?._id
                                                            ] || {}),
                                                            [dpName]: {
                                                              ...prev[
                                                                session?._id
                                                              ]?.[dpName],
                                                              status: false,
                                                            },
                                                          },
                                                        }),
                                                      );
                                                    }}
                                                  >
                                                    <KeyboardArrowRight
                                                      sx={{
                                                        fontSize: "1.25rem",
                                                      }}
                                                    />
                                                  </CustomIconButtonForSheet>
                                                ) : (
                                                  <CustomIconButtonForSheet
                                                    onClick={() => {
                                                      setDateChangedIdx(
                                                        (prev) => ({
                                                          ...prev,
                                                          [session?._id]: {
                                                            ...(prev?.[
                                                              session?._id
                                                            ] || {}),
                                                            [dpName]: {
                                                              ...prev[
                                                                session?._id
                                                              ]?.[dpName],
                                                              status: true,
                                                            },
                                                          },
                                                        }),
                                                      );
                                                    }}
                                                  >
                                                    <KeyboardArrowDown
                                                      sx={{
                                                        fontSize: "1.25rem",
                                                      }}
                                                    />
                                                  </CustomIconButtonForSheet>
                                                )
                                              ) : (
                                                <Box
                                                  sx={{
                                                    height: "1.5rem",
                                                    aspectRatio: "1",
                                                    display: "inline-flex",
                                                  }}
                                                ></Box>
                                              )}
                                            </Box>
                                          </StyledTableCell>
                                          <SheetDropdown
                                            customError={
                                              isManagePositions
                                                ? null
                                                : sessionDatesForDropdownV2?.[
                                                      session?._id
                                                    ]?.some(
                                                      (i) =>
                                                        i?.value ==
                                                        item?.startDate,
                                                    )
                                                  ? null
                                                  : "Value should be from options"
                                            }
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.startDate,
                                                "startDate",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            render={dayjs(
                                              item?.startDate,
                                            ).format("ddd MM/DD/YYYY")}
                                            options={
                                              sessionDatesForDropdownV2?.[
                                                session?._id
                                              ]
                                            }
                                            onChange={(option) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              }
                                              if (status) {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                                updateDateChangedIdx(
                                                  {
                                                    ...item,
                                                    startDate: option,
                                                  },
                                                  session?._id,
                                                  dpName,
                                                );
                                              }

                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals?.positions?.map(
                                                  (pos) => {
                                                    if (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos?._id === item?._id
                                                    ) {
                                                      return {
                                                        ...pos,
                                                        startDate: option,
                                                      };
                                                    } else {
                                                      return pos;
                                                    }
                                                  },
                                                ),
                                              }));

                                              setDateChangedIdx(itemIdx);
                                            }}
                                          />
                                          {isManagePositions ? (
                                            <SheetPositionDropdown
                                              onChange={(option) => {
                                                if (!status) {
                                                  addPositionToUpdatedList(
                                                    item?._id,
                                                  );
                                                }
                                                if (status) {
                                                  addMultiplePositionsToUpdatedList(
                                                    Ids,
                                                  );
                                                  updateDateChangedIdx(
                                                    {
                                                      ...item,
                                                      positionId:
                                                        option?.positionId,
                                                      positionName:
                                                        option?.positionName,
                                                    },
                                                    session?._id,
                                                    dpName,
                                                  );
                                                }

                                                setValues((vals) => ({
                                                  ...vals,
                                                  positions:
                                                    vals?.positions?.map(
                                                      (pos) => {
                                                        if (
                                                          status
                                                            ? Ids?.includes(
                                                                pos?._id,
                                                              )
                                                            : pos?._id ===
                                                              item?._id
                                                        ) {
                                                          return {
                                                            ...pos,
                                                            positionId:
                                                              option?.positionId,
                                                            positionName:
                                                              option?.positionName,
                                                          };
                                                        } else {
                                                          return pos;
                                                        }
                                                      },
                                                    ),
                                                }));

                                                setDateChangedIdx(itemIdx);
                                              }}
                                              text={
                                                isManagePositions
                                                  ? `${item?.positionName}${!status ? (suffixData?.[item?._id] ? "-" + suffixData?.[item?._id] : "") : ""}`
                                                  : `${item?.positionName}${item?.positionOrder && `-${item?.positionOrder}`}`
                                              }
                                              item={item}
                                            />
                                          ) : (
                                            <StyledTableCell>
                                              <LineClamp
                                                text={
                                                  isManagePositions
                                                    ? `${item?.positionName}${!status ? (suffixData?.[item?._id] ? "-" + suffixData?.[item?._id] : "") : ""}`
                                                    : `${item?.positionName}${item?.positionOrder && `-${item?.positionOrder}`}`
                                                }
                                                maxLines={1}
                                              />
                                            </StyledTableCell>
                                          )}
                                          <TableCellWithError
                                            sx={{ maxWidth: "5rem" }}
                                            key={`${item?._id}-quantity`}
                                            customError={errorsHere?.quantity}
                                          >
                                            <EditableCell
                                              renderedValue={status ? count : 1}
                                              // disableEditing={!status}
                                              value={
                                                status ? count : item?.quantity
                                              }
                                              onChange={(option) => {
                                                if (status) {
                                                  addMultiplePositionsToUpdatedList(
                                                    Ids,
                                                  );
                                                  if (option > count) {
                                                    increaseQuantityOfPositions(
                                                      option - count,
                                                      item,
                                                    );
                                                  } else {
                                                    decreaseQuantityOfPositions(
                                                      count - option,
                                                      item,
                                                      Ids,
                                                    );
                                                  }
                                                } else {
                                                  if (option > 1) {
                                                    increaseQuantityOfPositions(
                                                      option - 1,
                                                      item,
                                                    );
                                                  } else {
                                                    decreaseQuantityOfPositions(
                                                      1 - option,
                                                      item,
                                                      Ids,
                                                    );
                                                  }
                                                }
                                              }}
                                            />
                                          </TableCellWithError>
                                          <SheetTimeDropdown
                                            key={`${item?._id}-timeIn`}
                                            date={item?.startDate}
                                            customError={errorsHere?.timeIn}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.timeIn,
                                                "timeIn",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            render={
                                              item?.timeIn
                                                ? isTimeTBD(item?.timeIn)
                                                  ? "TBD"
                                                  : dayjs(item?.timeIn)?.format(
                                                      "hh:mm a",
                                                    )
                                                : "-"
                                            }
                                            value={dayjs(
                                              getTimeInAndTimeOutDates(
                                                item?.startDate,
                                                item?.timeIn,
                                              ),
                                            )}
                                            onChange={(e) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              }
                                              if (!e) return;

                                              let formattedDtStr = "TBD";
                                              if (e !== "TDB") {
                                                const hour = e
                                                  ?.split?.("T")?.[1]
                                                  ?.split?.(":")?.[0];
                                                const min = e
                                                  ?.split?.("T")?.[1]
                                                  ?.split?.(":")?.[1];
                                                // const hour = e?.$H;
                                                // const min = e?.$m;

                                                const dt = item?.startDate
                                                  ? dayjs(
                                                      item?.startDate,
                                                    ).toDate()
                                                  : dayjs(
                                                      session?.sessionStart,
                                                    ).toDate();

                                                dt?.setHours(hour);
                                                dt?.setMinutes(min);
                                                formattedDtStr =
                                                  getTSeparatedDate(dt);
                                              }

                                              if (status) {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                                updateDateChangedIdx(
                                                  {
                                                    ...item,
                                                    timeIn:
                                                      e === "TBD"
                                                        ? "TBD"
                                                        : formattedDtStr,
                                                  },
                                                  session?._id,
                                                  dpName,
                                                );
                                              }

                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals.positions?.map(
                                                  (pos) =>
                                                    (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos._id === item._id
                                                    )
                                                      ? {
                                                          ...pos,
                                                          timeIn:
                                                            e === "TBD"
                                                              ? "TBD"
                                                              : formattedDtStr,
                                                          tbd: e === "TBD",
                                                        }
                                                      : pos,
                                                ),
                                              }));
                                            }}
                                          />
                                          <SheetTimeDropdown
                                            key={`${item?._id}-timeOut`}
                                            date={item?.startDate}
                                            customError={errorsHere?.timeOut}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.timeOut,
                                                "timeOut",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            render={
                                              item?.timeOut
                                                ? isTimeTBD(item?.timeOut)
                                                  ? "TBD"
                                                  : dayjs(
                                                      item?.timeOut,
                                                    )?.format("hh:mm a")
                                                : "-"
                                            }
                                            value={dayjs(
                                              getTimeInAndTimeOutDates(
                                                item?.startDate,
                                                item?.timeOut,
                                              ),
                                            )}
                                            onChange={(e) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              }
                                              if (!e) return;

                                              let formattedDtStr = "TBD";
                                              if (e !== "TDB") {
                                                // const hour = e?.$H;
                                                // const min = e?.$m;
                                                const hour = e
                                                  ?.split?.("T")?.[1]
                                                  ?.split?.(":")?.[0];
                                                const min = e
                                                  ?.split?.("T")?.[1]
                                                  ?.split?.(":")?.[1];

                                                const dt = item?.startDate
                                                  ? dayjs(
                                                      item?.startDate,
                                                    ).toDate()
                                                  : dayjs(
                                                      session?.sessionStart,
                                                    ).toDate();

                                                if (item?.overNightShift) {
                                                  dt.setDate(dt.getDate() + 1);
                                                }

                                                dt?.setHours(hour);
                                                dt?.setMinutes(min);
                                                formattedDtStr =
                                                  getTSeparatedDate(dt);
                                              }

                                              if (status) {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                                updateDateChangedIdx(
                                                  {
                                                    ...item,
                                                    timeOut:
                                                      e === "TBD"
                                                        ? "TBD"
                                                        : formattedDtStr,
                                                  },
                                                  session?._id,
                                                  dpName,
                                                );
                                              }
                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals.positions?.map(
                                                  (pos) =>
                                                    (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos._id === item._id
                                                    )
                                                      ? {
                                                          ...pos,
                                                          timeOut:
                                                            e === "TBD"
                                                              ? "TBD"
                                                              : formattedDtStr,
                                                          tbd: e === "TBD",
                                                        }
                                                      : pos,
                                                ),
                                              }));
                                            }}
                                          />
                                          <TableCellWithError
                                            sx={{ maxWidth: "8rem" }}
                                            key={`${item?._id}-numberOfHours`}
                                            customError={
                                              // errorsHere?.numberOfHours?.split(".")?.[1]
                                              errorsHere?.numberOfHours
                                            }
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.numberOfHours,
                                                "numberOfHours",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                          >
                                            <EditableCell
                                              renderedValue={
                                                (isTimeTBD(item?.timeIn) ||
                                                  isTimeTBD(item?.timeOut)) &&
                                                item?.numberOfHours
                                                  ? `${item?.numberOfHours} ${item?.numberOfHours > 1 ? "Hours" : "Hour"}`
                                                  : "-"
                                              }
                                              value={item?.numberOfHours || 0}
                                              onChange={(option) => {
                                                if (!status) {
                                                  addPositionToUpdatedList(
                                                    item?._id,
                                                  );
                                                }
                                                if (status) {
                                                  addMultiplePositionsToUpdatedList(
                                                    Ids,
                                                  );
                                                  updateDateChangedIdx(
                                                    {
                                                      ...item,
                                                      numberOfHours: option,
                                                    },
                                                    session?._id,
                                                    dpName,
                                                  );
                                                }

                                                setValues((vals) => ({
                                                  ...vals,
                                                  positions:
                                                    vals?.positions?.map(
                                                      (pos) => {
                                                        if (
                                                          status
                                                            ? Ids?.includes(
                                                                pos?._id,
                                                              )
                                                            : pos?._id ===
                                                              item?._id
                                                        ) {
                                                          return {
                                                            ...pos,
                                                            numberOfHours:
                                                              option,
                                                          };
                                                        } else {
                                                          return pos;
                                                        }
                                                      },
                                                    ),
                                                }));
                                              }}
                                            />
                                          </TableCellWithError>
                                          <SheetCheckBox
                                            key={`${item?._id}-overnight`}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.overNightShift,
                                                "overNightShift",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            value={
                                              item?.overNightShift ?? false
                                            }
                                            onChange={(option) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              }
                                              if (status) {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                                updateDateChangedIdx(
                                                  {
                                                    ...item,
                                                    overNightShift: option,
                                                  },
                                                  session?._id,
                                                  dpName,
                                                );
                                              }
                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals?.positions?.map(
                                                  (pos) => {
                                                    if (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos?._id === item?._id
                                                    ) {
                                                      return {
                                                        ...pos,
                                                        overNightShift: option,
                                                        // timeOut: isTimeTBD(
                                                        //   item?.timeOut,
                                                        // )
                                                        //   ? "TBD"
                                                        //   : overnightTimeOut(
                                                        //       item,
                                                        //       option,
                                                        //     ),
                                                      };
                                                    } else {
                                                      return pos;
                                                    }
                                                  },
                                                ),
                                              }));
                                            }}
                                          />
                                          <SheetDropdown
                                            key={`${item?._id}-selectoption`}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.selectOption,
                                                "selectOption",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            render={getSelectedOption(
                                              item?.selectOption,
                                            )}
                                            options={lunchOptions}
                                            onChange={(option) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              } else {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                              }
                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals?.positions?.map(
                                                  (pos) => {
                                                    if (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos?._id === item?._id
                                                    ) {
                                                      return {
                                                        ...pos,
                                                        selectOption: option,
                                                      };
                                                    } else {
                                                      return pos;
                                                    }
                                                  },
                                                ),
                                              }));
                                            }}
                                          />
                                          <SheetDropdown
                                            key={`${item?._id}-complexity`}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.complexity,
                                                "complexity",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            render={item?.complexity || "none"}
                                            options={complexityOptions}
                                            onChange={(option) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              } else {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                              }
                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals?.positions?.map(
                                                  (pos) => {
                                                    if (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos?._id === item?._id
                                                    ) {
                                                      return {
                                                        ...pos,
                                                        complexity: option,
                                                      };
                                                    } else {
                                                      return pos;
                                                    }
                                                  },
                                                ),
                                              }));
                                            }}
                                          />
                                          <SheetDropdown
                                            key={`${item?._id}-attire`}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.attire,
                                                "attire",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                            render={
                                              item?.attire || "Tech Blacks"
                                            }
                                            options={attireOptions}
                                            onChange={(option) => {
                                              if (!status) {
                                                addPositionToUpdatedList(
                                                  item?._id,
                                                );
                                              } else {
                                                addMultiplePositionsToUpdatedList(
                                                  Ids,
                                                );
                                              }
                                              setValues((vals) => ({
                                                ...vals,
                                                positions: vals?.positions?.map(
                                                  (pos) => {
                                                    if (
                                                      status
                                                        ? Ids?.includes(
                                                            pos?._id,
                                                          )
                                                        : pos?._id === item?._id
                                                    ) {
                                                      return {
                                                        ...pos,
                                                        attire: option,
                                                      };
                                                    } else {
                                                      return pos;
                                                    }
                                                  },
                                                ),
                                              }));
                                            }}
                                          />
                                          <TableCellWithError
                                            customError={
                                              errorsHere?.additionalComments
                                            }
                                            sx={{ maxWidth: "9rem" }}
                                            onContextMenu={(e) => {
                                              handleContextMenu(
                                                e,
                                                item?.additionalComments,
                                                "additionalComments",
                                                item?._id,
                                                session?._id,
                                              );
                                            }}
                                          >
                                            <EditableCell
                                              value={
                                                item?.additionalComments ||
                                                "N/A"
                                              }
                                              onChange={(option) => {
                                                if (!status) {
                                                  addPositionToUpdatedList(
                                                    item?._id,
                                                  );
                                                } else {
                                                  addMultiplePositionsToUpdatedList(
                                                    Ids,
                                                  );
                                                }
                                                setValues((vals) => ({
                                                  ...vals,
                                                  positions:
                                                    vals?.positions?.map(
                                                      (pos) => {
                                                        if (
                                                          status
                                                            ? Ids?.includes(
                                                                pos?._id,
                                                              )
                                                            : pos?._id ===
                                                              item?._id
                                                        ) {
                                                          return {
                                                            ...pos,
                                                            additionalComments:
                                                              option,
                                                          };
                                                        } else {
                                                          return pos;
                                                        }
                                                      },
                                                    ),
                                                }));
                                              }}
                                            />
                                          </TableCellWithError>
                                          {!hideDelete && (
                                            <StyledTableCell>
                                              <Box
                                                sx={{
                                                  marginRight: "10px",
                                                  display: "flex",
                                                  justifyContent: "flex-end",
                                                  alignItems: "center",
                                                  gap: "0.5rem",
                                                }}
                                              >
                                                <CustomHelper
                                                  index={itemIdx}
                                                  message={"Copy this position"}
                                                >
                                                  <Button
                                                    sx={{
                                                      // marginLeft: "10px",
                                                      borderRadius: "10px",
                                                      // border: "1px solid #FFF",
                                                      background:
                                                        getCssVariableHandler({
                                                          variableName:
                                                            "--primary-pink-rgb",
                                                        }),
                                                      boxShadow:
                                                        "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                                                      minWidth: "auto",
                                                      padding: "5px !important",
                                                    }}
                                                    onClick={() => {
                                                      increaseQuantityOfPositions(
                                                        status ? count : 1,
                                                        item,
                                                        false,
                                                      );
                                                    }}
                                                  >
                                                    <ContentCopy fontSize="small" />
                                                  </Button>
                                                </CustomHelper>

                                                <CustomHelper
                                                  index={itemIdx}
                                                  message={
                                                    "Delete this position"
                                                  }
                                                >
                                                  <Button
                                                    sx={{
                                                      // marginLeft: "10px",
                                                      borderRadius: "10px",
                                                      // border: "1px solid #FFF",
                                                      background:
                                                        getCssVariableHandler({
                                                          variableName:
                                                            "--primary-pink-rgb",
                                                        }),
                                                      boxShadow:
                                                        "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                                                      minWidth: "auto",
                                                      padding: "5px !important",
                                                    }}
                                                    onClick={() => {
                                                      if (status) {
                                                        if (isEditMultiple) {
                                                          dispatch(
                                                            alertDialogAciton({
                                                              open: true,
                                                              title: "Warning",
                                                              message:
                                                                "Are you sure, you wish to delete these positions?",
                                                              onOk: () => {
                                                                deleteMultiplePositionsForEdit(
                                                                  {
                                                                    [session?._id]:
                                                                      Ids,
                                                                  },
                                                                  Ids,
                                                                );
                                                              },
                                                              okLabel: "Delete",
                                                              okTime: 5,
                                                            }),
                                                          );
                                                          return;
                                                        }
                                                        decreaseQuantityOfPositions(
                                                          count,
                                                          item,
                                                          Ids,
                                                        );
                                                      } else {
                                                        if (isEditMultiple) {
                                                          dispatch(
                                                            alertDialogAciton({
                                                              open: true,
                                                              title: "Warning",
                                                              message:
                                                                "Are you sure, you wish to delete this position?",
                                                              onOk: () => {
                                                                deleteMultiplePositionsForEdit(
                                                                  {
                                                                    [session?._id]:
                                                                      [
                                                                        item?._id,
                                                                      ],
                                                                  },
                                                                  [item?._id],
                                                                );
                                                              },
                                                              okLabel: "Delete",
                                                              okTime: 5,
                                                            }),
                                                          );
                                                          return;
                                                        }
                                                        if (
                                                          !isManagePositions
                                                        ) {
                                                          deletePositionFromSession(
                                                            item,
                                                          );
                                                          return;
                                                        }

                                                        setValues((prev) => ({
                                                          positions:
                                                            prev?.positions?.filter(
                                                              (pos) =>
                                                                pos?._id !==
                                                                item?._id,
                                                            ),
                                                        }));
                                                      }
                                                    }}
                                                  >
                                                    <DeleteOutline fontSize="small" />
                                                  </Button>
                                                </CustomHelper>
                                              </Box>
                                            </StyledTableCell>
                                          )}
                                        </StyledTableRow>
                                      )}
                                    </>
                                  );
                                })
                            )}
                          </TableBody>
                        </StyledTable>
                      </TableContainer>
                    </Box>
                  );
                })}
              </div>
            </Grid>
          </LocalizationProvider>

          {!hideSessions && (
            <Box
              sx={{
                // position: "absolute",
                margin: "0.5rem 0",
                marginBottom: isMediumScreen ? "0.5rem" : "0",
                bottom: "1rem",
                left: "1.2rem",
                overflowX: "auto",
                width: "auto",
                display: "flex",
                alignItems: "center",
                gap: "0.25rem",
              }}
            >
              {sessions?.map((item, i) => (
                <Box
                  sx={{
                    px: 2,
                    py: 1,
                    borderRadius: "0.5rem",
                    backgroundColor: getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    }),
                    cursor:
                      session?._id === item?._id ? "not-allowed" : "pointer",
                  }}
                  key={i}
                  onClick={() => {
                    if (session?._id === item?._id) return;
                    setFilters(filtersInitialValue);
                    setSorting(sortingInitialValue);
                    selectSession(null, item);
                  }}
                >
                  <Typography sx={{ fontSize: "18px", fontWeight: "700" }}>
                    <LineClamp text={item?.sessionName} maxLines={1} />
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
          <RightClick
            clickEvents={{
              applyToAll: () => handleApplyTo("ALL"),
              applyToSelected: () => handleApplyTo("SELECTED"),
            }}
            contextMenu={contextMenu}
            handleClose={() =>
              setContextMenu({
                status: false,
                mouseX: null,
                mouseY: null,
                value: null,
                field: null,
                sessionId: null,
              })
            }
          />

          {allowCopyPositions && (
            <RightCheckBoxClick
              clickEvents={{
                ...(checkBoxContextMenu?.type === "COPY"
                  ? {
                      copyRows: () => {
                        setCheckBoxContextMenu((prev) => ({
                          ...prev,
                          type: "PASTE",
                          status: false,
                        }));
                        const timeout = setTimeout(() => {
                          if (
                            checkBoxContextMenu?.collapsed?.status &&
                            !checkBoxContextMenu?.collapsed?.isSelected
                          ) {
                            setCopiedRows(
                              values?.positions?.filter((item) => {
                                if (
                                  checkBoxContextMenu?.collapsed?.Ids?.length
                                ) {
                                  return checkBoxContextMenu?.collapsed?.Ids?.includes(
                                    item?._id,
                                  );
                                } else {
                                  return checkBoxContextMenu?.id === item?._id;
                                }
                              }),
                            );
                          } else {
                            setCopiedRows(
                              values?.positions?.filter((item) => {
                                if (selectedPositions?.length) {
                                  return selectedPositions?.includes(item?._id);
                                } else {
                                  return checkBoxContextMenu?.id === item?._id;
                                }
                              }),
                            );
                          }
                          clearTimeout(timeout);
                        }, 200);
                      },
                    }
                  : {}),
                ...(copiedRows?.length > 0
                  ? {
                      insertAbove: () => handleInsert("ABOVE"),
                      insertBelow: () => handleInsert("BELOW"),
                      insertPaste: () => handleInsert("PASTE_DATE"),
                    }
                  : {}),
              }}
              contextMenu={checkBoxContextMenu}
              handleClose={() =>
                setCheckBoxContextMenu({
                  ...checkBoxContextInitialValues,
                  type: copiedRows?.length == 0 ? "COPY" : "PASTE",
                })
              }
            />
          )}

          <SessionSelectorForPositionBoard
            open={sessionSelection?.status}
            handleClose={closeSessionSelection}
            showNewModalIcon={true}
            selectedSessionIds={sessions?.map((session) => session?._id)}
            removeSessionHandler={(item) => {
              if (setViewPositionsData) {
                setViewPositionsData((viewPositionsData) => {
                  return {
                    ...viewPositionsData,
                    selectedSessions:
                      viewPositionsData?.selectedSessions?.filter?.(
                        (session) => {
                          return session?._id !== item?._id;
                        },
                      ),
                  };
                });
              }
            }}
            noDispatch={!isPositionBoard}
            onNewModalClick={(session) => {
              if (
                viewPositionsData?.selectedSessions?.length >= 2 &&
                !isPositionBoard
              ) {
                dispatch({
                  type: ALERT_DIALOG,
                  payload: {
                    open: true,
                    title: "Alert",
                    message:
                      "Only 2 sessions can be viewed at a time. Please remove a session and add another.",
                  },
                });
              } else {
                if (setViewPositionsData) {
                  setViewPositionsData((viewPositionsData) => {
                    return {
                      ...viewPositionsData,
                      selectedSessions: [
                        ...(viewPositionsData?.selectedSessions || []),
                        session,
                      ],
                    };
                  });
                }
              }
            }}
          />
        </Box>
      </Box>
    </Modal>
    </>
  );
}

SessionPositionEditableSheet.propTypes = {
  successCallback: PropTypes.func,
  data: PropTypes.object,
  session: PropTypes.object,
  timezone: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  eventInfo: PropTypes.object,
  getUnsbmittedPositions: PropTypes.func,
  sessionList: PropTypes.array,
  selectSession: PropTypes.func,
  hideSessions: PropTypes.bool,
  isManagePositions: PropTypes.bool,
  hideDelete: PropTypes.bool,
  sessions: PropTypes.any,
  viewPositionsData: PropTypes.any,
  setViewPositionsData: PropTypes.any,
  isEditMultiple: PropTypes.bool,
  isPositionBoard: PropTypes.bool,
  allowCopyPositions: PropTypes.bool,
};